<template>
  <div class="row ordersposContainer">
    <div :class="
      isInEditMode ? 'isInEditMode orderspos' : 'orderspos'
      ">
      <div class="floatBox">
        <!-- <div>
          <span>{{userData.firstname}}</span>
          <span>{{userData.lastname}}</span>
        </div> -->
        <!-- <div>
          <a href="#/order-pos-client-screen" target="_blanck">Ecran Client</a>
        </div> -->
        <!-- <div>
          <span>{{userData.email}}</span>
        </div> -->
      </div>
      <div class="middleSection">
        <div class="leftPart">
          <div class="topBar" v-if="!isInEditMode">
            <div class="topBar__left">
              <div :class="(client) ? 'client selected' : 'client'" @click="openClientModal()">
                <span>{{$t('addOrder.titleClient')}}</span>
                <div class="badge_wrapper">
                  <div class="badge"><span>1</span></div>
                  <button>
                    <span v-if="!client">Selecteaza Clientul</span>
                    <span v-if="client && (client.firstname || client.lastname)">{{client.firstname}} {{client.lastname}}</span>
                    <span v-else-if="client && client.email">{{client.email}}</span>
                  </button>
                </div>
              </div>
              <div class="method_btns">
                <span style="width: 100%; text-align: center;">{{$t('addOrder.titleMethod')}}</span>
                <div class="badge_wrapper">
                  <div class="badge"><span>2</span></div>
                  <div class="method_btns_wrapper">
                    <template v-for="method in company.delivery_options_labels">
                        <button v-if="method.enabled"
                                :disabled="!method.active || !client"
                                :class="(method.key === activeMethod) ? 'methodBtn active' : 'methodBtn' "
                                @click="changeMethod(method)"
                                >{{$t('settingCompany.' + method.key)}}</button>
                    </template>
                  </div>
                </div>
              </div>
              <div class="loc" v-if="!supraSelectedLocation">
                <span>{{$t('addOrder.titleLocation')}}</span>
                <div class="badge_wrapper">
                  <div class="badge"><span>3</span></div>
                  <div class="buttonWithSearch">
                    <button v-if="!selectedLocation"
                            :disabled="!activeMethod"
                            style="min-width: 150px;"
                            @click="dropdownLocationActive = !dropdownLocationActive">{{$t('addOrder.locSelect')}}</button>
                    <button v-else
                            class="active"
                            style="min-width: 150px;"
                            @click="dropdownLocationActive = !dropdownLocationActive">
                      <span>{{curentLocation.name}}</span>
                    </button>
                    <div class="buttonWithSearch_search" v-if="dropdownLocationActive">
                      <template v-for="loc in availableLocations">
                        <div class="searchList" @click="selectedLocationChanged(loc)">
                            <div class="">
                              <span>{{loc.name}}</span>
                            </div>
                        </div>
                      </template>
                    </div>
                  </div>
                  <!-- <select class="oneLocation" name="loc" :disabled="!activeMethod" v-model="selectedLocation" @change="selectedLocationChanged()">
                    <option v-if="!selectedLocation" :value='null' selected >{{$t('addOrder.locSelect')}}</option>
                    <template v-for="loc in availableLocations" >
                      <option :value="loc.id" v-if="!loc.notShow">
                        <span>{{loc.name}} - </span>
                        <span class="oneLocation__adress">{{loc.street}} {{loc.number}} {{loc.city}} {{loc.state}}</span>
                      </option>
                    </template>
                  </select> -->
                </div>
              </div>

              <div :class="(activeMethod && selectedLocation && activeMethod == 'delivery') ? 'adress' : 'adress disabled'"
                    @click="openAdressModal()"
                    >
                <span>{{$t('addOrder.titleAdress')}}</span>
                <div class="badge_wrapper">
                  <div class="badge" v-if="supraSelectedLocation"><span>3</span></div>
                  <div class="badge" v-if="!supraSelectedLocation"><span>4</span></div>
                  <button :class="(client && client.address) ? 'active' : ''">
                    <span v-if="!client || (client && !client.address)">Selecteaza Adresa</span>
                    <span v-if="client && client.address">{{client.address.address_name}} {{client.address.street}} {{client.address.number}}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div :class="(activeMethod && selectedLocation) ? 'productList_wrapper' : 'productList_wrapper disabled'">
            <div class="productList_wrapper_left">
              <div :class="(loading ? 'show-loader' : 'hide-loader')">
                <div class="el-loading-spinner">
                  <svg viewBox="25 25 50 50" class="circular">
                    <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
                  </svg><!---->
                </div>
              </div>
              <div class="productList_filter">
                <h3>Categorii</h3>
              </div>
              <div class="filter">
                <div class="filter__bar">
                  <div class="filter__cat">
                    <!-- <button>Toate</button> -->
                    <template v-for="cat in category">
                      <a @click="getProducts(cat.id)" :class="(cat.id == selectedCategory) ? 'selected' : '' "
                        :style="'background-image: url('+cat.image+');'"
                      >
                        <button>{{cat.name}}</button>
                      </a>
                    </template>
                  </div>
                </div>
              </div>
            </div>

            <div class="productList_wrapper_right">
              <div class="productList_topBar">
                <h3>Produse</h3>
                <div v-if="canScrollProductList">
                  <button class="scrollBtnProductList up" @click="scrollUpProductList">&#11165;</button>
                  <button class="scrollBtnProductList down"@click="scrollDownProductList">&#11167;</button>
                </div>
                <div class="search_wrapper">
                  <div :class="searchFilterShow ? 'filter__search showw' : 'filter__search'">
                    <div class="search">
                      <span class="icosearch">
                        <svg xmlns="http://www.w3.org/2000/svg" width="25.863" height="25.863" viewBox="0 0 25.863 25.863">
                          <g id="Icon_feather-search" data-name="Icon feather-search" transform="translate(1.5 1.5)">
                            <path id="Path_24745" data-name="Path 24745" d="M24.27,14.385A9.885,9.885,0,1,1,14.385,4.5,9.885,9.885,0,0,1,24.27,14.385Z" transform="translate(-4.5 -4.5)" fill="none" stroke="#909090" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                            <path id="Path_24746" data-name="Path 24746" d="M30.35,30.35l-5.375-5.375" transform="translate(-8.109 -8.109)" fill="none" stroke="#909090" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                          </g>
                        </svg>
                      </span>
                      <input type="text" ref="searchText" :placeholder="$t('addOrder.searchProduct')" v-model="searchText" @input="newText()">
                      <span :class="showRemoveTextFromSearch ? 'closeSearch show' : 'closeSearch' " @click="deleteTextFromSearch()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="22.698" height="22.698" viewBox="0 0 22.698 22.698">
                          <path id="Icon_ionic-ios-close-circle" data-name="Icon ionic-ios-close-circle" d="M14.724,3.375A11.349,11.349,0,1,0,26.073,14.724,11.347,11.347,0,0,0,14.724,3.375ZM17.6,18.833l-2.875-2.875-2.875,2.875A.872.872,0,1,1,10.615,17.6l2.875-2.875-2.875-2.875a.872.872,0,0,1,1.233-1.233l2.875,2.875L17.6,10.615a.872.872,0,0,1,1.233,1.233l-2.875,2.875L18.833,17.6a.876.876,0,0,1,0,1.233A.866.866,0,0,1,17.6,18.833Z" transform="translate(-3.375 -3.375)" fill="#909090"/>
                        </svg>
                      </span>
                    </div>
                  </div>
                  <!-- <div class="searchBtn" @click="searchBtn()">
                    <div :class="(searchText && searchText.length) ? 'circle used' : 'circle'">
                      <template v-if="searchFilterShow">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M217.9 256L345 129c9.4-9.4 9.4-24.6 0-33.9-9.4-9.4-24.6-9.3-34 0L167 239c-9.1 9.1-9.3 23.7-.7 33.1L310.9 417c4.7 4.7 10.9 7 17 7s12.3-2.3 17-7c9.4-9.4 9.4-24.6 0-33.9L217.9 256z"/></svg>
                      </template>
                      <template v-else>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25.863" height="25.863" viewBox="0 0 25.863 25.863">
                          <g id="Icon_feather-search" data-name="Icon feather-search" transform="translate(1.5 1.5)">
                            <path id="Path_24745" data-name="Path 24745" d="M24.27,14.385A9.885,9.885,0,1,1,14.385,4.5,9.885,9.885,0,0,1,24.27,14.385Z" transform="translate(-4.5 -4.5)" fill="none" stroke="#909090" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                            <path id="Path_24746" data-name="Path 24746" d="M30.35,30.35l-5.375-5.375" transform="translate(-8.109 -8.109)" fill="none" stroke="#909090" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                          </g>
                        </svg>
                      </template>
                    </div>
                  </div> -->
                </div>
              </div>
              <div class="productList" ref="productList">
                <div :class="(loading ? 'show-loader' : 'hide-loader')">
                  <div class="el-loading-spinner">
                    <svg viewBox="25 25 50 50" class="circular">
                      <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
                    </svg><!---->
                  </div>
                </div>
                <div :class="(((!activeMethod || !selectedLocation) && !loading) ? 'show-loader' : 'hide-loader')">
                  <div class="el-loading-spinner">
                    <h1>{{$t('addOrder.pleaseSelectMethodAndLoc')}}</h1>
                  </div>
                </div>
                <!-- <template v-for="cat in products"> -->
                  <!-- <div class="productcat" :id="'cat-' + cat.details.id"> -->
                    <!-- <span>{{cat.details.name}}</span> -->
                    <template v-for="product in products">
                      <div class="product" @click="openProduct(product)">
                        <div class="product_img_title">
                          <template v-if="product.image_url">
                            <div class="productImage" @click.stop="addProductDirectlyToCart(product)" 
                            :style="'background-image: url(\'' + product.image_url + '\');'"></div>
                            <!-- <img :src="product.image_url" :alt="product.name"> -->
                          </template>
                          <p class="prod_title">{{product.name}}</p>
                        </div>
                        <p class="prod_price">{{product.price_details.formatted_price}}</p>
                      </div>
                    </template>
                  <!-- </div> -->
                <!-- </template> -->
              </div>
            </div>

          </div>
        </div>
        <div class="rightPart">
          <div class="orderDetails_title">
            <p>{{$t('addOrder.orderDet')}}</p>
            <div class="right-box">
              <div class="settings-box">
                <div class="location statusAndHour">
                  <div class="statuses" v-if="availableStatuses && (availableStatuses.ON_HOLD || availableStatuses.POSTPONED || availableStatuses.PROCESSING || availableStatuses.DELIVERED)">
                    <div class="buttonWithSearch">
                      <button class="active" v-if="selectedStatus" @click="showStatusDropdown = !showStatusDropdown">{{$t('addOrder.titleStatus')}}: {{$t('ordersStatus.'+selectedStatus)}}</button>
                      <div class="buttonWithSearch_search" v-if="showStatusDropdown">
                        <div class="searchList" @click="selectedStatus = 'NEW'; showStatusDropdown = false">
                            <div class="">
                              <span>{{$t('ordersStatus.NEW')}}</span>
                            </div>
                        </div>
                        <template v-for="(acive, status) in availableStatuses">
                          <div class="searchList" @click="selectedStatus = status; showStatusDropdown = false" v-if="acive">
                              <div class="">
                                <span>{{$t('ordersStatus.' + status )}}</span>
                              </div>
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="curentLocation && !curentLocation.deactivate_delivery_hour_usage" class="hour">
                  <div v-if="activeMethod && selectedLocation">
                    <button class="openHourDateBtn" @click="openHourDate()">
                      <img src="/static/img/icons/ios-time.png">
                      <template v-if="selectedDate">{{formatDate(selectedDate)}}</template>
                      <template v-if="selectedHour && !curentLocation.just_date_delivery_hour_usage">{{selectedHour}}</template>
                    </button>
                  </div>
                </div>
              </div>
              <div class="zoom" @click="goFullScreen()">
                <svg id="Component_2_1" data-name="Component 2 – 1" xmlns="http://www.w3.org/2000/svg" width="58" height="60" viewBox="0 0 58 60">
                  <rect id="Rectangle_6606" data-name="Rectangle 6606" width="58" height="60" rx="10" fill="#f3f3f3"/>
                  <g id="Icon_feather-maximize-2" data-name="Icon feather-maximize-2" transform="translate(20 21)">
                    <path id="Path_24778" data-name="Path 24778" d="M22.5,4.5h6.141v6.141" transform="translate(-10.218 -4.5)" fill="none" stroke="#8f8f8f" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                    <path id="Path_24779" data-name="Path 24779" d="M10.641,28.641H4.5V22.5" transform="translate(-4.5 -10.218)" fill="none" stroke="#8f8f8f" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                    <path id="Path_24780" data-name="Path 24780" d="M28.164,4.5,21,11.664" transform="translate(-9.742 -4.5)" fill="none" stroke="#8f8f8f" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                    <path id="Path_24781" data-name="Path 24781" d="M4.5,28.164,11.664,21" transform="translate(-4.5 -9.742)" fill="none" stroke="#8f8f8f" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                  </g>
                </svg>
              </div>
            </div>
          </div>
          <div :class="(activeMethod && selectedLocation) ? 'cartDetail_wrapper' : 'cartDetail_wrapper disabled'">
            <div class="settings">
                <div class="commentOrder" @click="openCommentModal">
                  <img src="/static/img/icons/chat.png">
                </div>
                <div class="displayClient" v-if="!isFullScreen">
                  <a href="#/order-pos-client-screen" target="_blanck">
                    <img src="/static/img/icons/display-frame.png">
                  </a>
                </div>
                <div class="settings" @click="others()" v-if="!isFullScreen">
                  <img src="/static/img/icons/settings.png">
                </div>
                <div class="toGo">
                  <div class="form-group" style="margin-top: 2px;">
                    <label for="toGo">{{$t('addOrder.toGo')}}
                      <p-switch id="toGo" name="toGo" v-model="toGo" type="success"></p-switch>
                    </label>
                  </div>
                </div>
            </div>
            <div class="cartDetail">
              <div class="verify-card">
                <div class="cartDetail__head" >
                  <p>{{$t('addOrder.cartDet')}}</p>
                  <button class="emptyCart" v-if="cart && cart.myCart && cart.myCart.products.length && !isInEditMode" @click="emptyCart">
                    <svg xmlns="http://www.w3.org/2000/svg" width="13.769" height="16.523" viewBox="0 0 13.769 16.523">
                      <path id="Icon_ionic-md-trash" data-name="Icon ionic-md-trash" d="M8.127,19.191a1.839,1.839,0,0,0,1.836,1.832h7.343a1.839,1.839,0,0,0,1.836-1.832V8.631H8.127ZM20.519,5.877H17.077L15.924,4.5H11.345L10.192,5.877H6.75V7.254H20.519Z" transform="translate(-6.75 -4.5)" fill="#ff3b30"/>
                    </svg>
                  </button>
                </div>
                <div :class="[{ big: isInEditMode, heightbig: isFullScreen }, 'products']" v-if="cart && cart.myCart && company">
                  <template v-if="cart && cart.myCart && company && cart.myCart.products.length">
                    <template v-for="(prod, index) in cart.myCart.products">
                      <div class="product">

                        <span>{{prod.name}}</span>
                        <span v-if="prod.extra" style="display: block;">{{prod.extra}}</span>
                        <span v-if="prod.additional_info" style="display: block; color: #0099FF;">{{$t('addOrder.info')}}: {{prod.additional_info}}</span>
                        <span v-if="prod.is_bonus" style="display: block; color: #20C598;">{{$t('addOrder.freeProd')}}</span>
                        <span v-if="prod.partial_pay" @click="modifyProduct(prod)" style="display: block; color: #f3bb45;">{{$t('addOrder.partialPay')}}</span>
                        <div class="product_wrapper">
                          <div class="quantity">
                            <button @click="editToCartUpdateQuantity(prod.quantity-1, prod.id, prod.index)">-</button>
                            <span>{{prod.quantity}}</span>
                            <button @click="editToCartUpdateQuantity(prod.quantity+1, prod.id, prod.index)">+</button>
                          </div>
                          <div class="product_right">
                            <div>
                              <span>{{prod.price.toFixed(2)}} {{company.currency_symbol}}</span>
                            </div>
                            <button class="product__modify" @click="modifyProduct(prod)">{{$t('addOrder.modif')}}</button>
                            <button class="product__delete" @click="deleteProductPopup(prod.id, prod.index)">X</button>
                          </div>
                        </div>

                      </div>
                    </template>
                  </template>
                  <template v-else>
                    <div class="noProducts">
                      <p>{{$t('general.noProductPos')}}</p>
                    </div>
                  </template>
                </div>
              </div>
            </div>

            <div class="location"  v-if="!isInEditMode && curentLocation && !company.flag_fast_order_from_admin">
              <p>{{$t('addOrder.selectPayment')}}</p>
              <div style="width: 60%;">
                <div class="payMethod">
                    <button v-if="payMethod != 'free' && posIsAvailable" @click="payMethod = 'pos'" :class="(payMethod == 'pos') ? 'active' : ''">{{$t('addOrder.pos')}}</button>
                    <div v-if="payMethod != 'free' && !posIsAvailable" ></div>
                    <button v-if="payMethod != 'free' && cashIsAvailable" @click="payMethod = 'cash'" :class="(payMethod == 'cash') ? 'active' : ''">{{$t('addOrder.cash')}}</button>
                    <button v-if="(!company.print_fiscal_from_dashboard)" @click="payMethod = 'protocol'" :class="(payMethod == 'protocol') ? 'active' : ''">{{$t('addOrder.protocol')}}</button>
                    <button v-if="payMethod === 'free'" @click="payMethod = 'free'" :class="(payMethod == 'free') ? 'active' : ''">{{$t('addOrder.free')}}</button>
                </div>
              </div>
            </div>

            <!-- <div class="location marketing"  v-if="curentLocation">
              <div class="buttons" v-if="cart">
                <button v-if="cart.use_coupon_discount && cart.coupon_discount_value <= 0" @click="addOrRemoveCupon(1)" class="discount">{{$t('addOrder.addCoupon')}}</button>
                <button v-if="cart.use_coupon_discount && cart.coupon_discount_value > 0" @click="addOrRemoveCupon(0)" class="discount">{{$t('addOrder.removeCoupon')}}</button>
                <template v-if="$session.get('selectedCompany') != 109">
                  <button v-if="cart.use_loyalty_points && !cart.loyalty_discount_value" @click="useOrRemoveLoyaltyPoints(1)" class="loyalty_points">{{$t('general.applyPoints') }} {{client.loyalty_points}}</button>
                  <button v-if="cart.use_loyalty_points && cart.loyalty_discount_value" @click="useOrRemoveLoyaltyPoints(0)" class="loyalty_points">Sterge punctele {{client.loyalty_points}}</button>
                </template>
                <button v-if="cart.use_tips && cart.order_totals.find( ({ name }) => name === 'Tip').value <= 0" @click="addOrRemoveTip(1)" class="tips">{{$t('addOrder.addTip')}}</button>
                <button v-if="cart.use_tips && cart.order_totals.find( ({ name }) => name === 'Tip').value > 0" @click="addOrRemoveTip(0)" class="tips">{{$t('addOrder.removeTip')}}</button>
              </div>
            </div> -->

            <!-- <div class="box-com">
              <div v-if="client" class="client">
                <div>{{ $t('general.loyaltyPoints') }} {{client.loyalty_points}}</div>
              </div>
            </div> -->
            <div class="total-box" v-if="cart && cart.myCart && company">
              <div class="location marketing"  v-if="curentLocation">
                <div class="buttons" v-if="cart">
                  <button v-if="cart.use_coupon_discount && cart.coupon_discount_value <= 0" @click="addOrRemoveCupon(1)" class="discount">{{$t('addOrder.addCoupon')}}</button>
                  <button v-if="cart.use_coupon_discount && cart.coupon_discount_value > 0" @click="addOrRemoveCupon(0)" class="discount">{{$t('addOrder.removeCoupon')}}</button>
                  <template v-if="$session.get('selectedCompany') != 109">
                    <button v-if="cart.use_loyalty_points && !cart.loyalty_discount_value" @click="useOrRemoveLoyaltyPoints(1)" class="loyalty_points">{{$t('general.applyPoints') }} {{client.loyalty_points}}</button>
                    <button v-if="cart.use_loyalty_points && cart.loyalty_discount_value" @click="useOrRemoveLoyaltyPoints(0)" class="loyalty_points">Sterge punctele {{client.loyalty_points}}</button>
                  </template>
                  <button v-if="cart.use_tips && cart.order_totals.find( ({ name }) => name === 'Tip').value <= 0" @click="addOrRemoveTip(1)" class="tips">{{$t('addOrder.addTip')}}</button>
                  <button v-if="cart.use_tips && cart.order_totals.find( ({ name }) => name === 'Tip').value > 0" @click="addOrRemoveTip(0)" class="tips">{{$t('addOrder.removeTip')}}</button>
                </div>
              </div>
              <!-- <div class="bottomPart" v-if="showCommentSection">
                <div class="textAndBtns">
                  <div class="textarea">
                    <textarea name="comentariu" cols="30" rows="2" :placeholder="$t('addOrder.coment')" v-model="orderComent"></textarea>
                  </div>
                  <div class="textarea" v-if="isInEditMode">
                    <textarea name="client_notif" cols="30" rows="2" :placeholder="$t('addOrder.client_notif')" v-model="orderClientNotification"></textarea>
                  </div>
                </div>
              </div> -->
              <div class="addToCart">
                <template v-for="totalsOptions in (cart.order_totals || [])">
                  <template v-if="totalsOptions.use">
                    <div class="totalsOptions" v-if="totalsOptions.value != 0">
                      <span>{{totalsOptions.name}}</span>
                      <span>{{totalsOptions.value}} {{company.currency_symbol}}</span>
                    </div>
                  </template>
                </template>
                <div class="total">
                  <span>{{$t('addOrder.total')}}</span>
                  <span>{{cart.myCart.total_cart_price}} {{company.currency_symbol}}</span>
                </div>
                <button v-if="isInEditMode" class="orderNow" @click="editOrderNow()" :disabled="loadingCompleteOrder || loadingAddRemoveRequest > 0">{{$t('addOrder.editOrderNow')}}</button>
                <button v-if="!isInEditMode && (!company.print_fiscal_from_dashboard)" class="orderNow" @click="orderNow()" :disabled="loadingCompleteOrder || loadingAddRemoveRequest > 0">{{$t('addOrder.orderNow')}}</button>
              </div>
              <div v-if="!isInEditMode && (company.print_fiscal_from_dashboard)" class="print-fiscal-buttons">
                  <input type="text" name="cui" class="input" :placeholder="$t('orders.cui')" v-model="orderCui">
                  <button @click="openPayModal" class="pay-button">
                    {{$t('paymentPage.pay')}}
                  </button>
                  <!-- <button @click="orderNow(1)" class="orderWithPaymentButton cash" :disabled="loadingCompleteOrder">{{$t('orders.cash')}}</button>
                  <button @click="orderNow(2)" class="orderWithPaymentButton card" :disabled="loadingCompleteOrder">{{$t('orders.card')}}</button>
                  <button @click="orderNow()"  class="orderWithPaymentButton blue" :disabled="loadingCompleteOrder">{{$t('addOrder.orderNow')}}</button>
                  <button @click="orderNow(8)" class="orderWithPaymentButton blue" :disabled="loadingCompleteOrder">{{$t('orders.card_no_pos')}}</button>
                  <button @click="orderNow(7)" class="orderWithPaymentButton blue" :disabled="loadingCompleteOrder">{{$t('orders.online')}}</button>
                  <button @click="others()" class="orderWithPaymentButton orange" :disabled="loadingCompleteOrder">{{$t('addOrder.other')}}</button> -->
                  <!-- <button @click="generateRaport('X')" class="orderWithvalue: 'X',PaymentButton" :disabled="loadingCompleteOrder">Raport X</button>
                  <button @click="generateRaport('Z')" class="orderWithPaymentButton" :disabled="loadingCompleteOrder">Raport Z</button> -->
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>

    <!-- Definirea modalului -->
    <vmodal name="payModal" title="Pay Modal" class="payModal" width="950" height="310" :maxWidth="950" :minWidth="200" :adaptive="true">
      <div class="modal-content">
        <div class="actionTitle">
          <p>{{$t('addOrder.choosePay')}}</p>
        </div>
        <template v-if="company.payment_btns_v2">
          <div class="actionButton">
            <div class="row" style="width: 100%; display: flex; align-items: center; justify-content: space-around;">
              <button @click="orderNow(1)" style="width: 30%; margin: 0;" class="orderWithPaymentButton cash" :disabled="loadingCompleteOrder || loadingAddRemoveRequest > 0">{{$t('orders.cash')}}</button>
              <button @click="orderNow(8)" style="width: 30%; margin: 0;" class="orderWithPaymentButton blue card" :disabled="loadingCompleteOrder || loadingAddRemoveRequest > 0">{{$t('orders.card')}}</button> <!-- 8 = card_no_pos -->
              <button @click="orderNow(9)" style="width: 30%; margin: 0;" class="orderWithPaymentButton blue" :disabled="loadingCompleteOrder || loadingAddRemoveRequest > 0">{{$t('orders.virament')}}</button>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="actionButton">
            <div class="row">
              <button @click="orderNow(1)" class="orderWithPaymentButton cash" :disabled="loadingCompleteOrder || loadingAddRemoveRequest > 0">{{$t('orders.cash')}}</button>
              <button @click="orderNow(8)" class="orderWithPaymentButton noPos" :disabled="loadingCompleteOrder || loadingAddRemoveRequest > 0">{{$t('orders.card_no_pos')}}</button>
            </div>
            <div class="row">
              <button @click="orderNow(7)" class="orderWithPaymentButton blue" :disabled="loadingCompleteOrder || loadingAddRemoveRequest > 0">{{$t('orders.online')}}</button>
              <button @click="orderNow(2)" class="orderWithPaymentButton blue card" :disabled="loadingCompleteOrder || loadingAddRemoveRequest > 0">{{$t('orders.card')}}</button>
              <button @click="orderNow()" class="orderWithPaymentButton blue" :disabled="loadingCompleteOrder || loadingAddRemoveRequest > 0">{{$t('addOrder.orderNow')}}</button>
              <!-- <button @click="others()" class="orderWithPaymentButton orange" :disabled="loadingCompleteOrder">{{$t('addOrder.other')}}</button> -->
            </div>
          </div>
        </template>
      </div>
    </vmodal>

    <vmodal name="commentModal" class="comment-modal" width="550" height="290" :maxWidth="950" :minWidth="200" :adaptive="true">
      <div class="modal-content">
        <div class="modal-header">
          <p class="title">{{ $t('addOrder.commentTitle') }}</p>
        </div>
        <div class="modal-body">
          <div class="textAndBtns">
            <div class="textarea">
              <textarea
                name="comentariu"
                cols="30"
                rows="2"
                :placeholder="$t('addOrder.coment')"
                v-model="orderComent">
              </textarea>
            </div>
            <div class="textarea" v-if="isInEditMode">
              <textarea
                name="client_notif"
                cols="30"
                rows="2"
                :placeholder="$t('addOrder.client_notif')"
                v-model="orderClientNotification">
              </textarea>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="submitComment">Save</button>
        </div>
      </div>
    </vmodal>

    <vmodal name="userModal"
            title="userModal"
            class="userModal"
            width="70%"
            :maxWidth="800"
            :minWidth="200"
            height="90%"
            :adaptive="true"
      >
      <div class="header">
        <h2>{{$t('addOrder.existingClient')}}</h2>
        <div class="tagg">
          <template v-for="tag in availableTags" >
            <button @click="selectedTag = tag" :class="selectedTag === tag ? 'active' : ''">{{tag}}</button>
          </template>
          <!-- <select class="oneTag" name="loc" :disabled="!selectedLocation" v-model="selectedTag">
            <template v-for="tag in availableTags" >
              <option :value="tag">
                <span>{{$t('addOrder.' + tag)}}</span>
              </option>
            </template>
          </select> -->
        </div>
      </div>

      <template v-if="client">
        <div class="content" style="overflow: hidden;height: auto;">
          <div class="content_scrool">
            <div class="add_client_wrapper">
              <h3>{{$t('addOrder.clientSelected')}}</h3>
              <button class="add_client" @click="addNewClient()" v-if="new_client">{{$t('addOrder.clearFields')}}</button>
            </div>
            <p>{{$t('addOrder.contactPers')}}</p>
            <div class="fields__wrapper">
              <div class="fields">
                <div>
                  <label for="name">{{$t('addOrder.prodId')}}</label>
                  <input type="text" name="name" v-model="client.id" disabled>
                </div>
              </div>
              <br>
              <div class="fields">
                <div>
                  <label for="name">{{$t('addOrder.lastName')}}</label>
                  <input type="text" name="name" v-model="client.lastname">
                </div>
                <div>
                  <label for="name">{{$t('addOrder.firstName')}}</label>
                  <input type="text" name="name" v-model="client.firstname">
                </div>
              </div>
              <div class="fields">
                <div>
                  <label for="phone">{{$t('customers.phone')}}</label>
                  <template v-if="client_phone_is_empty">
                    <input type="text" name="phone" v-model="client.phone">
                  </template>
                  <template v-else>
                    <input type="text" disabled name="phone" v-model="client.phone">
                  </template>
                </div>
                <div>
                  <label for="email">{{$t('customers.email')}}</label>
                  <input type="text" disabled name="email" v-model="client.email">
                </div>
              </div>
            </div>
            <div class="fields__wrapper" style="justify-content: flex-start;
                                                flex-direction: row;
                                                align-items: center;
                                                ">
              <div class="datepicker">
                <label>
                  <span>{{$t('addOrder.birthdate')}}</span>
                  <el-date-picker type="date"
                                  v-model="client.birthdate"
                                  value-format="yyyy-MM-dd"
                                  format="dd/MM/yyyy"
                                  :picker-options="pickerOptions">
                  </el-date-picker>
                </label>
              </div>
              <div class="sex">
                <label class="sex__title">Sex</label>
                <label for="Masculin">
                  <input type="radio" name="gender" value="M" id="Masculin" v-model="client.gender" :placeholder="$t('addOrder.sexm')">
                  <span>{{$t('addOrder.sexm')}}</span>
                </label>
                <label for="Feminin">
                  <input type="radio" name="gender" value="F" id="Feminin" v-model="client.gender" :placeholder="$t('addOrder.sexf')">
                  <span>{{$t('addOrder.sexf')}}</span>
                </label>
              </div>
            </div>
            <div>
              <div class="fields__wrapper" v-if="activeMethod == 'eat_location'">
                <label for="">
                  <span>{{$t('addOrder.how_many')}}</span>
                  <input type="number" v-model="how_many" min="1" max="1000">
                </label>
              </div>
            </div>
            <div>
              <button class="goToClient" @click="goToClient(client.id)">Go To Client</button>
            </div>
          </div>
        </div>
        <div class="userModal__footer">
          <button @click="saveClient()">{{$t('addOrder.save1')}}</button>
        </div>
      </template>
      <template v-else>
        <div class="content" style="overflow: hidden;height: auto;">
          <h3>{{$t('addOrder.newclient')}}</h3>
          <p>{{$t('addOrder.contactperson')}}</p>
          <div class="fields__wrapper">
            <div class="fields">
              <div class="inputWithSearch">
              <label for="name">{{$t('addOrder.prodId')}}</label>
                <input type="text" ref="clientIdRef" autocomplete="none" :class="new_clientErrors.id" v-model="new_client.id" title="name" v-on:keyup="searchById">
                <div class="inputWithSearch_search" v-if="existingId.length">
                  <template v-for="client in existingId">
                    <div class="client" @click="selectClient(client)">
                        <div class="client__details">
                          <span v-if="client.firstname">{{client.firstname}}</span>
                          <span v-if="client.lastname">{{client.lastname}}</span>
                          <span v-if="!client.firstname && !client.lastname">{{client.email}}</span>
                        </div>
                        <div class="client__adress">
                          <span v-if="client.phone">{{client.phone}}</span>
                        </div>
                    </div>
                  </template>
                </div>
              </div>
              <div class="inputWithSearch" v-if="canAddNoClient">
                <div class="select_default">
                  <button @click="{selectClient(defaultUser); selectedTag = 'inlocation'}">{{$t('addOrder.noClient')}}</button>
                </div>
              </div>
            </div>
            <br>
            <div class="fields">
              <div class="inputWithSearch">
              <label for="name">{{$t('addOrder.lastName')}}</label>
                <input type="text" autocomplete="none" :class="new_clientErrors.lastname" v-model="new_client.lastname" title="name" v-on:keyup="searchByName2()">
                <div class="inputWithSearch_search" v-if="existingNames2.length">
                  <template v-for="client in existingNames2">
                    <div class="client" @click="selectClient(client)">
                        <div class="client__details">
                          <span v-if="client.firstname">{{client.firstname}}</span>
                          <span v-if="client.lastname">{{client.lastname}}</span>
                          <span v-if="!client.firstname && !client.lastname">{{client.email}}</span>
                        </div>
                        <div class="client__adress">
                          <span v-if="client.phone">{{client.phone}}</span>
                        </div>
                    </div>
                  </template>
                </div>
              </div>

              <div class="inputWithSearch">
                <label for="name">{{$t('addOrder.firstName')}}</label>
                <input type="text" autocomplete="none" :class="new_clientErrors.firstname" v-model="new_client.firstname" title="name" v-on:keyup="searchByName()">
                <div class="inputWithSearch_search" v-if="existingNames.length">
                  <template v-for="client in existingNames">
                    <div class="client" @click="selectClient(client)">
                        <div class="client__details">
                          <span v-if="client.firstname">{{client.firstname}}</span>
                          <span v-if="client.lastname">{{client.lastname}}</span>
                          <span v-if="!client.firstname && !client.lastname">{{client.email}}</span>
                        </div>
                        <div class="client__adress">
                          <span v-if="client.phone">{{client.phone}}</span>
                        </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
            <div class="fields">

              <div class="inputWithSearch">
                <label for="phone">{{$t('customers.phone')}}</label>
                <button class="autoPhone" v-if="company.use_calling_phone" @click="autocompletePhone()">{{$t('customers.use_calling_phone')}}</button>
                <input type="text" autocomplete="none" :class="new_clientErrors.phone" v-model="new_client.phone" title="phone" v-on:keyup="searchByPhone()">
                <div class="inputWithSearch_search" v-if="existingPhones.length">
                  <template v-for="client in existingPhones">
                    <div class="client" @click="selectClient(client)">
                        <div class="client__details">
                          <span v-if="client.firstname">{{client.firstname}}</span>
                          <span v-if="client.lastname">{{client.lastname}}</span>
                          <span v-if="!client.firstname && !client.lastname">{{client.email}}</span>
                        </div>
                        <div class="client__adress">
                          <span v-if="client.phone">{{client.phone}}</span>
                        </div>
                    </div>
                  </template>
                </div>
              </div>

              <div class="inputWithSearch">
                <label for="email">Email</label>
                <input type="text" autocomplete="none" :class="new_clientErrors.email" v-model="new_client.email" title="email" v-on:keyup="searchByEmail()">
                <div class="inputWithSearch_search" v-if="existingEmails.length">
                  <template v-for="client in existingEmails">
                    <div class="client" @click="selectClient(client)">
                        <div class="client__details">
                          <span>{{client.email}}</span>
                        </div>
                        <!-- <div class="client__adress"> -->
                          <!-- <span v-if="client.phone">{{client.phone}}</span> -->
                        <!-- </div> -->
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div class="fields__wrapper" style="justify-content: flex-start;
                                              flex-direction: row;
                                              align-items: center;
                                              ">
            <div class="datepicker">
              <label>
                <span>{{$t('addOrder.birthdate')}}</span>
                <el-date-picker type="date"
                                v-model="new_client.birthdate"
                                value-format="yyyy-MM-dd"
                                format="dd/MM/yyyy"
                                :picker-options="pickerOptions">
                </el-date-picker>
              </label>
            </div>
            <div class="sex">
              <label class="sex__title">{{$t('addOrder.sex')}}</label>
              <label for="Masculin">
                <input type="radio" name="gender" value="M" id="Masculin" v-model="new_client.gender" :placeholder="$t('addOrder.sexm')">
                <span>{{$t('addOrder.sexm')}}</span>
              </label>
              <label for="Feminin">
                <input type="radio" name="gender" value="F" id="Feminin" v-model="new_client.gender" :placeholder="$t('addOrder.sexf')">
                <span>{{$t('addOrder.sexf')}}</span>
              </label>
            </div>
            <!-- <div class="addAccount">
              <label for="addAccount">
                <input type="checkbox" id="addAccount" v-model="new_client.add_account">
                <span>Creează un cont de aplicație</span>
              </label>
            </div> -->
          </div>
        </div>
        <div class="userModal__footer">
          <button @click="addClient()">{{$t('addOrder.add')}}</button>
        </div>
      </template>
    </vmodal>

    <vmodal name="adressModal"
            title="adressModal"
            class="adressModal"
            width="70%"
            height="90%"
            :maxWidth="800"
            :minWidth="200"
            :adaptive="true"
      >
      <div class="header">
        <h2>{{$t('addOrder.newadress')}}</h2>
      </div>
      <div class="content" v-if="client">
        <div class="content_scrool">
          <h3 v-if="client && client.addresses.length">Adresele Clientului</h3>
          <div class="addresses">
            <template v-for="adr in client.addresses">
              <div class="adr2">
                <div :class="(client.address && client.address.id == adr.id) ? 'adr selected' : 'adr'" @click="selectAdress(adr)">
                  <p><b>{{adr.address_name}}</b></p>
                  <p>{{adr.street}} {{adr.number}} {{adr.city}} {{adr.state}}</p>
                </div>
                <div class="deleteAdress__wrapper">
                  <button class="deleteAdress" @click="deleteAdress(adr.id)">Delete</button>
                </div>
              </div>
            </template>
          </div>
          <div class="" v-if="!client.address || (client.address && !client.address.id)">
            <h3>{{$t('addOrder.deliveryAdress')}}</h3>
            <div class="fields__wrapper">
              <div class="fields">
                <div>
                  <label for="address_name">{{$t('addOrder.adressname')}}</label>
                  <input type="text" name="address_name" v-model="new_client.address_name">
                </div>
                <div>
                  <label for="address_street">{{$t('addOrder.street')}}</label>
                  <input type="text" name="address_street" :class="new_clientErrors.address_street" v-model="new_client.address_street">
                </div>
              </div>
              <div class="fields">
                <div>
                  <label for="address_number">{{$t('addOrder.number')}}</label>
                  <input type="text" name="address_number" :class="new_clientErrors.address_number" v-model="new_client.address_number">
                </div>
                <div>
                  <label for="address_apartment">{{$t('addOrder.adress')}}</label>
                  <input type="text" name="address_apartment" :class="new_clientErrors.address_apartment" v-model="new_client.address_apartment">
                </div>
              </div>
              <div class="fields">
                <div>
                  <label for="address_city">{{$t('addOrder.city')}}</label>
                  <input type="text" name="address_city" :class="new_clientErrors.address_city" v-model="new_client.address_city">
                </div>
                <div>
                  <label for="address_county">{{$t('addOrder.state')}}</label>
                  <input type="text" name="address_county" :class="new_clientErrors.address_county" v-model="new_client.address_county">
                </div>
              </div>
            </div>
          </div>
          <div class="" v-if="client.address && client.address.id">
            <div class="add_client_wrapper">
              <h3>{{$t('addOrder.deliveryAdressEdit')}}</h3>
              <button class="add_client" @click="addNewAdress()" >{{$t('addOrder.clearFields')}}</button>
            </div>
            <div class="fields__wrapper">
              <div class="fields">
                <div>
                  <label for="address_name">{{$t('addOrder.adressname')}}</label>
                  <input type="text" name="address_name" v-model="client.address.address_name">
                </div>
                <div>
                  <label for="address_street">{{$t('addOrder.street')}}</label>
                  <input type="text" name="address_street" :class="new_clientErrors.address_street" v-model="client.address.street">
                </div>
              </div>
              <div class="fields">
                <div>
                  <label for="address_number">{{$t('addOrder.number')}}</label>
                  <input type="text" name="address_number" :class="new_clientErrors.address_number" v-model="client.address.number">
                </div>
                <div>
                  <label for="address_apartment">{{$t('addOrder.adress')}}</label>
                  <input type="text" name="address_apartment" :class="new_clientErrors.address_apartment" v-model="client.address.apartment">
                </div>
              </div>
              <div class="fields">
                <div>
                  <label for="address_city">{{$t('addOrder.city')}}</label>
                  <input type="text" name="address_city" :class="new_clientErrors.address_city" v-model="client.address.city">
                </div>
                <div>
                  <label for="address_county">{{$t('addOrder.state')}}</label>
                  <input type="text" name="address_county" :class="new_clientErrors.address_county" v-model="client.address.state">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="userModal__footer" v-if="client">
        <button @click="addAddress()" v-if="!client.address || (client.address && !client.address.id)">{{$t('addOrder.add')}}</button>
        <button @click="editAddress()" v-if="client.address && client.address.id">{{$t('addOrder.edit')}}</button>
      </div>
    </vmodal>

    <vmodal name="productModal"
            class="productModal"
            width="90%"
            height="90%"
            :maxWidth="755"
            :minWidth="200"
            :adaptive="true"
      >
      <div class="productModal__wrapper">
        <template v-if="currentProductInPopup && currentProductInPopup.image_url[0]['url']">
          <div class="photo" :style="'background-image: url(\''+currentProductInPopup.image_url[0]['url']+'\');'">
              <!-- <img :src="currentProductInPopup.image_url[0]['url']" :alt="currentProductInPopup.name"> -->
          </div>
        </template>
        <div class="productModal__product" v-if="currentProductInPopup">
          <div class="title__wraper">
            <div class="title">
              <p>{{currentProductInPopup.name}}</p>
              <p>{{currentProductInPopup.price_details.formatted_price}}</p>
            </div>
            <div>
              <template v-if="currentProductInPopup.description && currentProductInPopup.description.length > 255">
                <p>{{currentProductInPopup.description.substring(0, 255)}}...</p>
              </template>
              <template v-else>
                <p>{{currentProductInPopup.description}}</p>
              </template>
            </div>
          </div>
        </div>

        <div class="options__wrapper" v-if="currentProductInPopup">
          <div class="option" v-for="(option, optionIdx) in currentProductInPopup.product_options">
            <p>{{option.name}} <span v-if="option.min_no">Min: {{option.min_no}}</span> <span v-if="option.max_no">Max: {{option.max_no}}</span></p>
            <div class="options">
              <div v-for="(values, valuesIdx) in option.values">
                <label :for="values.id">
                  <template v-if="(option.type === 'checkbox')">
                    <input :type="option.type"
                        :name="option.id"
                        :value="values.id"
                        :id="values.id"
                        @change="updateCategories()"
                        v-model="values.checked"
                  >
                  </template>
                  <template v-else-if="(option.type === 'radio')">
                    <input :type="option.type"
                        :name="option.id"
                        :value="values.id"
                        :id="values.id"
                        @change="updateCategories()"
                        v-model="option.checked"
                  >
                  </template>
                  <template v-else-if="(option.type === 'upload')">
                    <input type="file"
                        :name="option.id"
                        :ref="values.id"
                        :id="values.id"
                        @change="updateCategories()"
                      >
                  </template>

                  <span>{{values.name}} <span v-if="values.price > 0">(+ {{values.price}} {{currentProductInPopup.price_details.currency_symbol}})</span></span>
                </label>
                <div class="img" v-if="(option.type === 'upload') && values.checked" style="margin-bottom: 20px;">
                  <img v-bind:src="values.file" style="max-width: 70px;max-height: 70px;">
                  <span @click="removeImage(optionIdx, valuesIdx)" style="color: #FF0D19; margin-left: 20px; font-size: 20px; font-weight: 500;">X</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="info__wrapper" v-if="currentProductInPopup && currentProductInPopup.allow_user_comments">
          <p>{{$t('addOrder.infosup')}}</p>
          <textarea name="info" v-model="currentProductInPopup.additional_info"></textarea>
        </div>

        <div class="other_info" v-if="currentProductInPopup && currentProductInPopup.other_info.length">
          <el-collapse accordion>
            <div class="info" v-for="other_info in currentProductInPopup.other_info">
              <el-collapse-item :title="other_info.title" :name="other_info.id">
                <div class="description">
                  <span v-html="other_info.description"></span>
                </div>
              </el-collapse-item>
            </div>
          </el-collapse>
        </div>

      </div>

      <div class="footer" v-if="currentProductInPopup">
        <div class="footer__quantity">
          <button @click="updateQuantity(currentProductInPopup, 0)">-</button>
          <span>{{currentProductInPopup.quantity}}</span>
          <button @click="updateQuantity(currentProductInPopup, 1)">+</button>
        </div>
        <div class="footer__price">
          <span>{{$t('addOrder.total')}}</span>
          <span><b>{{currentProductInPopup.price_details.price}} {{currentProductInPopup.price_details.currency_symbol}}</b></span>
          <span v-if="currentProductInPopup.partial_pay" @click="changePrice()" style="
              background: #0099FF;
              color: #EFF9FE;
              text-transform: uppercase;
              font-weight: 500;
              font-size: 20px;
              border: 0 solid #707070;
              border-radius: 10px;
              padding: 10px 12px;
          ">{{$t('addOrder.modif')}}</span>
        </div>
        <div class="footer__addToCart">
          <template v-if="currentProductInPopup.in_edit">
            <button :disabled="addToCartDisabled" @click="editToCart()">{{$t('addOrder.edit')}}</button>
          </template>
          <template v-else>
            <button :disabled="addToCartDisabled" @click="addToCart()">{{$t('addOrder.add')}}</button>
          </template>
        </div>
      </div>
    </vmodal>

    <vmodal name="hourDateModal"
            class="hourDateModal"
            width="90%"
            height="50%"
            :maxWidth="755"
            :minWidth="200"
            :adaptive="true"
      >
      <div class="dateSelect">
        <template v-if="curentLocation && ((curentLocation.hour_and_date_delivery_hour_usage && !noDate) || curentLocation.just_date_delivery_hour_usage)">
          <div class="form-group">
            <label>{{$t('addOrder.datepicker')}}</label>
            <br/>
            <el-date-picker type="date"
                            v-model="selectedDate"
                            name="Date"
                            :clearable="false"
                            value-format="yyyy-MM-dd"
                            format="dd/MM/yyyy"
                            @change="selectedDateChange($event)"
                            :picker-options="{ firstDayOfWeek: 1, disabledDate: (time) => disabledEndDate(time) }">
            </el-date-picker>
          </div>
        </template>
        <div v-if="choosenHours && !curentLocation.just_date_delivery_hour_usage" class="available_hours_today">
          <label for="hourpicker">{{$t('addOrder.hourpicker')}}</label>
          <select name="available_hours_today" v-model="selectedHour" @change="">
            <template v-for="(hour, key) in choosenHours" >
              <option :value="hour">
                <template v-if="key === 0">
                  <span>{{$t('addOrder.fast')}}: </span>
                </template>
                <span>{{hour}}</span>
              </option>
            </template>
          </select>
        </div>
        <div class="directBtns">
            <button v-if="choosenHours && choosenHours[1]"
                    @click="selectedHour = choosenHours[1]"
                    :class="selectedHour === choosenHours[1] ? 'active' : ''"
            >{{choosenHours[1]}}</button>

            <button v-if="choosenHours && choosenHours[2]"
                    @click="selectedHour = choosenHours[2]"
                    :class="selectedHour === choosenHours[2] ? 'active' : ''"
            >{{choosenHours[2]}}</button>

            <button v-if="choosenHours && choosenHours[3]"
                    @click="selectedHour = choosenHours[3]"
                    :class="selectedHour === choosenHours[3] ? 'active' : ''"
            >{{choosenHours[3]}}</button>

            <button v-if="choosenHours && choosenHours[4]"
                    @click="selectedHour = choosenHours[4]"
                    :class="selectedHour === choosenHours[4] ? 'active' : ''"
            >{{choosenHours[4]}}</button>

            <button v-if="choosenHours && choosenHours[5]"
                    @click="selectedHour = choosenHours[5]"
                    :class="selectedHour === choosenHours[5] ? 'active' : ''"
            >{{choosenHours[5]}}</button>
        </div>
      </div>
      <div class="userModal__footer">
        <button @click="$modal.hide('hourDateModal')">{{$t('addOrder.done')}}</button>
      </div>
    </vmodal>

    <div class="mySwal2" id="mySwal2"></div>

  </div>
</template>
<script>
  import Vue from 'vue'
  import {Input, Table, TableColumn, Row, Select, Option, Checkbox, CheckboxGroup, Dropdown, DropdownMenu, DropdownItem, DatePicker} from 'element-ui'
  import DataTables from 'vue-data-tables'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import vmodal from 'vue-js-modal'
  import swal from 'sweetalert2'

  // import OrderForm from './OrderView.vue'
  Vue.use(Input)
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)
  Vue.use(DataTables)
  Vue.use(Row)
  Vue.use(Checkbox)
  Vue.use(CheckboxGroup)
  Vue.use(Dropdown)
  Vue.use(DropdownMenu)
  Vue.use(DropdownItem)
  Vue.use(vmodal, { componentName: 'vmodal' })


  export default {
    components: {
      [DatePicker.name]: DatePicker,
      PPagination,
      PSwitch
    },
    computed: {
    },
    created: function () {
      let time = 60000
      let databaseName = 'tapTasty_' + this.$session.get('selectedCompany')
      let versionDB = 2 // onupgradeneeded event if change the version
      this.openDatabaseAndReadOrCreate(databaseName, versionDB, 'menuForAdminOrder', 0)
      clearInterval(window.intervalForDatabaseCache)
      window.intervalForDatabaseCache = setInterval(() => {
        this.openDatabaseAndReadOrCreate(databaseName, versionDB, 'menuForAdminOrder', 1)
      }, time)


      localStorage.removeItem('order_for_' + this.$session.get('selectedCompany'))
      localStorage.setItem('order_for_' + this.$session.get('selectedCompany') + '_add_tip', JSON.stringify(null))
      this.userData = JSON.parse(this.$session.get('userData'))
      if (this.$route.query.order_id) {
        this.isInEditMode = true
        this.selectedOrderForEdit = parseInt(this.$route.query.order_id)
        this.getOrderForEdit()
        return 0
      }
      if (this.$route.query.location) {
        this.supraSelectedLocation = true
        this.selectedLocation = this.$route.query.location
      }
      if (!document.body.classList.contains('sidebar-mini')) {
        document.body.classList.toggle('sidebar-mini')
      }
      if (!document.body.classList.contains('onPos')) {
        document.body.classList.add('onPos')
      }
      this.getUserData()
      this.filterForstatusEntered()
      this.$bus.$off('orders_pos_complete_order')
      this.$bus.$on('orders_pos_complete_order', this.ordersPosCompleteOrder)
      this.$bus.$off('completePaymentPos')
      this.$bus.$on('completePaymentPos', this.completePaymentPos)
    },
    destroyed: function () {
      clearInterval(window.intervalForDatabaseCache)
      if (document.body.classList.contains('onPos')) {
        document.body.classList.remove('onPos')
      }
    },
    beforeDestroy () {
      this.$refs.CalendarInline && this.$refs.CalendarInline.destroyCalendar()
      localStorage.removeItem('order_for_' + this.$session.get('selectedCompany'))
      localStorage.setItem('order_for_' + this.$session.get('selectedCompany') + '_add_tip', JSON.stringify(null))
    },
    data () {
      return {
        toGo: false,
        showCommentSection: false,
        canScrollProductList: false,
        userData: null,
        availableStatuses: [],
        timeoutTipFromClientView: null,
        tipFromClientView: null,
        selectedStatus: 'NEW',
        showStatusDropdown: 0,
        dropdownLocationActive: false,
        noDate: 0,
        selectedDate: null,
        selectedHour: null,
        curentLocation: null,
        choosenHours: null,
        how_many: 1,
        newTextTimeout: null,
        selectedCategory: null,
        loadingCompleteOrder: false,
        loadingAddRemoveRequest: 0,
        preventInfiniteLoopGetCart: 1,
        orderComent: '',
        orderClientNotification: '',
        payMethod: '',
        payment_options: [],
        posIsAvailable: false,
        cashIsAvailable: true,
        cartToken: null,
        newAdress: false,
        new_clientErrors: {
          'count': 0,
          'email': '',
          'phone': '',
          'gender': '',
          'birthdate': '',
          'firstname': '',
          'address_street': '',
          'address_number': '',
          'address_city': '',
          'address_apartment': ''
        },
        addToCartDisabled: false,
        currentProductInPopup: null,
        cart: null,
        currency: this.$session.get('selectedCompanyData')['currency_iso'],
        canAddNoClient: this.$session.get('selectedCompanyData')['print_fiscal_from_dashboard'],
        searchFilterShow: true,
        products: [],
        category: [],
        searchClient: '',
        not2timeSsearchForClient: 1,
        not2timeByPhone: 1,
        not2timeByEmail: 1,
        not2timeByName: 1,
        not2timeByName2: 1,
        not2timeById: 1,
        searchByIdPressEnter: 0,
        pickerOptions: {
          // disabledDate (time) {
          //   if ((time.getTime() + 86401 * 1000) < Date.now()) {
          //     return true
          //   } else {
          //     return false
          //   }
          // }
        },
        company: [],
        availableLocations: null,
        activeMethod: null,
        selectedLocation: null,
        supraSelectedLocation: false,
        selectedOrderForEdit: null,
        isInEditMode: false,
        selectedTag: 'phone',
        availableTags: this.getOrderFormFlags(),
        client_phone_is_empty: true,
        client: null,
        new_client: {},
        existingClients: [],
        existingPhones: [],
        existingEmails: [],
        existingNames: [],
        existingNames2: [],
        existingId: [],
        showRemoveTextFromSearch: 0,
        searchText: '',
        isFullScreen: false,
        loading: false,
        defaultUser: [],
        orderCui: ''
      }
    },
    mounted () {
      // this.getProducts()
      if (this.$route.query.fullscreen) {
        document.body.addEventListener('click', () => {
          if (this.$route.query.fullscreen && !this.isFullScreen) {
            this.goFullScreen()
          }
        }, true)
      }
      this.getTipFromClientView()
    },
    methods: {
      scrollUpProductList () {
        const scrollAmount = this.$refs.productList.offsetHeight / 1.5
        this.$refs.productList.scrollTop -= scrollAmount
      },
      scrollDownProductList () {
        const scrollAmount = this.$refs.productList.offsetHeight / 1.5
        this.$refs.productList.scrollTop += scrollAmount
      },
      checkScrollProductList () {
        const productList = this.$refs.productList
        if (productList) {
          this.canScrollProductList = productList.scrollHeight > productList.clientHeight
        }
      },
      getTipFromClientView () {
        clearInterval(this.timeoutTipFromClientView)
        this.timeoutTipFromClientView = setInterval(() => {
          this.tipFromClientView = parseFloat(JSON.parse(localStorage.getItem('order_for_' + this.$session.get('selectedCompany') + '_add_tip')))
          if (this.cart && this.cart.shopping_cart_id && (this.tipFromClientView > 0 || this.tipFromClientView === 0)) {
            clearInterval(this.timeoutTipFromClientView)
            this.setTip(this.tipFromClientView, (response) => {
              if (response.status === true) {
                localStorage.setItem('order_for_' + this.$session.get('selectedCompany') + '_add_tip', JSON.stringify(null))
              }
              this.getTipFromClientView()
            })
          }
        }, 500)
      },
      getOrderForEdit () {
        var data = {
          token: this.$session.get('token'),
          order_id: this.selectedOrderForEdit,
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/get-order-for-edit', 'GET', data, (response) => {
          if (response.status === true) {
            this.cart = response.data
            this.cartToken = response.data.shopping_cart_id
            // this.client = null
            this.activeMethod = response.data.delivery_type.toLowerCase()
            this.selectedLocation = response.data.location.id
            // this.getPaymentProfile()
            // this.getGategories()
            this.getProducts()
            // if (this.activeMethod === 'pick_up') {
            //   this.selectClient(this.client, null, true)
            // }
          }
        })
      },
      formatDate (date) {
        let d = new Date()
        if (date) {
          d = new Date(date)
        }
        let month = '' + (d.getMonth() + 1)
        let day = '' + d.getDate()
        let year = d.getFullYear()

        if (month.length < 2) month = '0' + month
        if (day.length < 2) day = '0' + day

        return [day, month, year].join('-')
      },
      selectedDateChange () {
        if (!this.curentLocation.just_date_delivery_hour_usage) {
          let dayIndex = new Date(this.selectedDate).getDay()
          this.choosenHours = this.curentLocation.available_hours[dayIndex]
          this.selectedHour = this.curentLocation.available_hours[dayIndex][0]
        }
        if (this.curentLocation.offset === '0' && this.isToday(this.selectedDate)) {
          this.choosenHours = this.curentLocation.available_hours_today
          this.selectedHour = this.curentLocation.available_hours_today[0]
        }
      },
      disabledEndDate (date) {
        var dat = new Date(Date.now() + (this.curentLocation.period_range.start * 24 * 60 * 60 * 1000))
        var year = dat.getFullYear()
        var month = dat.getMonth() + 1
        var day = dat.getDate()

        let end = this.curentLocation.period_range.end + this.curentLocation.period_range.start - 1

        var dat2 = new Date(Date.now() + (end * 24 * 60 * 60 * 1000))
        var year2 = dat2.getFullYear()
        var month2 = dat2.getMonth() + 1
        var day2 = dat2.getDate()

        return date.getTime() < new Date(year + '-' + month + '-' + day + ' 00:00:00').getTime() ||
                date.getTime() > new Date(year2 + '-' + month2 + '-' + day2 + ' 00:00:00').getTime() ||
                this.curentLocation.disabled_days.includes(date.getDay())
      },
      editOrderNow () {
        this.loadingCompleteOrder = true
        var dataToBeSent = {
          token: this.$session.get('token'),
          action: 'edit_order',
          company_id: this.$session.get('selectedCompany'),
          shopping_cart_id: this.cart.shopping_cart_id,
          comments: this.orderComent,
          client_notification: this.orderClientNotification,
          add_order: true,
          edit_order: true
        }
        this.apiRequest('/update-cart', 'PUT', dataToBeSent, (response) => {
          if (response.status === true) {
            this.$router.push('/orders/view/' + this.cart.order_id)
          }
          this.loadingCompleteOrder = false
        })
      },
      orderNow (payMethod = 0) {
        this.loadingCompleteOrder = true
        this.loading = true
        if (payMethod > 0) {
          this.payMethod = 'pos'
          if (payMethod === 1) {
            this.payMethod = 'cash'
          }
          if (payMethod === 9) {
            this.payMethod = 'virament'
          }
        }

        this.$modal.hide('payModal')

        let errors = 0
        if (!this.client) {
          swal({
            title: '',
            text: this.$t('addOrder.errorProduct5'),
            type: 'error',
            showConfirmButton: true,
            target: document.getElementById('mySwal2'),
            toast: true
          })
          errors++
        }
        if (this.activeMethod === 'delivery' && !this.client.address) {
          swal({
            title: '',
            text: this.$t('addOrder.errorProduct7'),
            type: 'error',
            showConfirmButton: true,
            target: document.getElementById('mySwal2'),
            toast: true
          })
          errors++
        }
        if (this.payMethod === '') {
          swal({
            title: '',
            text: this.$t('addOrder.errorProduct6'),
            type: 'error',
            showConfirmButton: true,
            target: document.getElementById('mySwal2'),
            toast: true
          })
          errors++
        }
        if (!this.selectedLocation || !this.activeMethod) {
          swal({
            title: '',
            text: this.$t('addOrder.errorProduct4'),
            type: 'error',
            showConfirmButton: true,
            target: document.getElementById('mySwal2'),
            toast: true
          })
          errors++
        }
        if (this.activeMethod !== 'eat_location' && (!this.cart || !this.cart.myCart || !this.cart.myCart.products.length)) {
          swal({
            title: '',
            text: this.$t('addOrder.errorProduct3'),
            type: 'error',
            showConfirmButton: true,
            target: document.getElementById('mySwal2'),
            toast: true
          })
          errors++
        }
        if (!errors) {
          var data2 = {
            token: this.$session.get('token'),
            action: 'product_validation',
            products_need_deleted: true,
            add_order: true,
            company_id: this.$session.get('selectedCompany'),
            shopping_cart_id: this.cart.shopping_cart_id
          }
          this.apiRequest('/update-cart', 'PUT', data2, (response) => {
            if (response.status === true) {
              if (!this.applyUpdateCartResponse(response)) {
                this.loadingCompleteOrder = false
                this.loading = false
                return
              }
              if (this.activeMethod !== 'eat_location' && !this.cart.myCart.products.length) {
                swal({
                  title: '',
                  text: this.$t('addOrder.errorProduct1'),
                  type: 'error',
                  showConfirmButton: true,
                  target: document.getElementById('mySwal2'),
                  toast: true
                })
              }
              if (response.data.some_products_deleted) {
                swal({
                  title: '',
                  text: this.$t('addOrder.errorProduct1'),
                  type: 'error',
                  showConfirmButton: true,
                  target: document.getElementById('mySwal2'),
                  toast: true
                })
              }

              if (
                this.company.print_fiscal_from_dashboard &&
                !this.company.is_not_waiting_for_pos_admin &&
                payMethod
                ) {
                var data = {
                  token: this.$session.get('token'),
                  pay_method: payMethod,
                  with_pos: false,
                  company_id: this.$session.get('selectedCompany'),
                  capture_transaction_response: '',
                  receipt_number: '',
                  cui: this.orderCui,
                  orderid: this.cart.order_id,
                  total: this.cart.myCart.total_cart_price
                }
                if (payMethod === 2) {
                  this.$bus.$emit('fiscalPosPayment', data)
                  // completeOrder after fiscalEvent is ok (completePaymentPos)
                } else {
                  this.completeOrder(payMethod)
                }
              } else {
                this.completeOrder(payMethod)
              }
              setTimeout(() => {
                this.printOrders()
              }, 2000)
            } else {
              this.loadingCompleteOrder = false
              this.loading = false
            }
          })
        } else {
          this.loadingCompleteOrder = false
          this.loading = false
        }
      },
      generateRaport (raport) {
        this.loadingCompleteOrder = true
        this.$bus.$emit('getRaport', raport)
        setTimeout(() => {
          this.loadingCompleteOrder = false
        }, 2000)
      },
      ordersPosCompleteOrder (data) {
        if (!this.company.is_not_waiting_for_pos_admin && data.with_pos) {
          if (data) {
            this.completeOrder(data.pay_method)
          } else {
            // ERROR
            this.loadingCompleteOrder = false
            this.loading = false
            swal({
              title: '',
              text: this.$t('addOrder.errorProduct8'),
              type: 'error',
              showConfirmButton: true,
              target: document.getElementById('mySwal2'),
              toast: true
            })
          }
        }
      },
      completePaymentPos (data) {
        if (!this.company.is_not_waiting_for_pos_admin) {
          if (data) {
            this.completeOrder(data.pay_method)
          } else {
            // ERROR
            this.loadingCompleteOrder = false
            this.loading = false
            swal({
              title: '',
              text: this.$t('addOrder.errorProduct8'),
              type: 'error',
              showConfirmButton: true,
              target: document.getElementById('mySwal2'),
              toast: true
            })
          }
        }
      },
      completeOrder (payMethod) {
        if (!this.cart || !this.cart.myCart) {
          this.loadingCompleteOrder = false
          this.loading = false
          return
        }
        this.loadingCompleteOrder = true
        let oldOrderId = this.cart.order_id
        let totalValue = this.cart.myCart.total_cart_price
        const cid = parseInt(this.$session.get('selectedCompany'))
        if (this.toGo) {
          this.orderComent += ' ' + this.$t('addOrder.toGo')
        }
        var data2 = {
          token: this.$session.get('token'),
          action: 'complete_order',
          products_need_deleted: true,
          add_order: true,
          chosen_hour: this.selectedHour,
          chosen_date: this.formatDate(this.selectedDate),
          company_id: cid,
          shopping_cart_id: this.cart.shopping_cart_id,
          payment_type: this.payMethod,
          order_from: this.selectedTag,
          selected_status: this.selectedStatus,
          comments: this.orderComent
        }
        this.orderComent = ''
        this.toGo = false
        this.apiRequest('/update-cart', 'PUT', data2, (response) => {
          this.loadingCompleteOrder = false
          this.loading = false
          if (response.status === true) {
            this.applyUpdateCartResponse(response)
            if (response.data && response.data.shopping_cart_id) {
              this.cartToken = response.data.shopping_cart_id
            }
            localStorage.removeItem('order_for_' + data2.company_id)
            const orderId = oldOrderId || (response.data && response.data.order_id)
            if (orderId) {
              if (cid === 109) {
                this.client = null
                location.reload()
              } else {
                if (this.company.print_fiscal_from_dashboard && payMethod !== 9) {
                  var data = {
                    token: this.$session.get('token'),
                    pay_method: payMethod,
                    with_pos: true,
                    company_id: this.$session.get('selectedCompany'),
                    capture_transaction_response: '',
                    receipt_number: '',
                    cui: this.orderCui,
                    orderid: orderId,
                    total: totalValue
                  }
                  if (this.company.is_not_waiting_for_pos_admin) {
                    // first we send order to be printed
                    data.with_pos = true
                    if (payMethod) {
                      this.$bus.$emit('fiscalEvent', data) // CARD AND PRINT
                    }
                  } else {
                    data.with_pos = false
                    if (payMethod) {
                      this.$bus.$emit('fiscalEvent', data) // JUST PRINT
                    }
                  }

                  if (!this.company.flag_fast_order_from_admin) {
                    this.client = null
                    this.$router.push('/orders/view/' + orderId)
                  } else {
                    this.cart = null
                    this.getTheCart(null, 1)
                  }
                } else {
                  if (this.company.flag_fast_order_from_admin) {
                    this.$router.push('/orders/view/' + orderId)
                  } else {
                    this.client = null
                    this.$router.push('/orders/view/' + orderId)
                  }
                }
              }
            }
          }
        })
      },
      goToClient (clientId) {
        window.open('/#/customers/view/' + clientId, '_blank')
      },
      getUserData () {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          from_admin: true
        }
        var url = ''
        var user = JSON.parse(this.$session.get('userData'))
        if (user.id) {
          url = '/profile/' + user.id
        } else {
          url = '/profile/me'
        }

        this.apiRequest(url, 'GET', data, (response) => {
          if (response.status === true) {
            this.apiRequest('/delivery-type', 'GET', data, (response2) => {
              if (response2.status === true) {
                this.company = response.data[0].company
                this.defaultUser = response.data[0]
                let executedChangeMethod = 0
                if (this.company.flag_fast_order_from_admin) {
                  this.selectClient(this.defaultUser)
                  this.selectedTag = 'inlocation'
                } else {
                  if (!this.client) {
                    setTimeout(() => {
                      this.openClientModal()
                    }, 10)
                  }
                }
                if (!this.defaultUser.phone) {
                  this.defaultUser.phone = this.company.default_order_phone
                }
                for (var i = 0; i < this.company.delivery_options_labels.length; i++) {
                  if (this.company.delivery_options_labels[i].key === 'pick_up') {
                    this.company.delivery_options_labels[i].active = response2.data.pickup
                    this.company.delivery_options_labels[i].enabled = response2.data.pickup_enabled

                    if (
                          this.company.delivery_options_labels[i].active &&
                          this.company.delivery_options_labels[i].enabled &&
                          this.company.flag_fast_order_from_admin &&
                          !this.activeMethod &&
                          !executedChangeMethod
                        ) {
                      this.changeMethod(this.company.delivery_options_labels[i])
                      executedChangeMethod = 1
                    }
                  }
                  if (this.company.delivery_options_labels[i].key === 'delivery') {
                    this.company.delivery_options_labels[i].active = response2.data.delivery
                    this.company.delivery_options_labels[i].enabled = response2.data.delivery_enabled

                    if (
                          this.company.delivery_options_labels[i].active &&
                          this.company.delivery_options_labels[i].enabled &&
                          this.company.flag_fast_order_from_admin &&
                          !this.activeMethod &&
                          !executedChangeMethod
                        ) {
                      this.changeMethod(this.company.delivery_options_labels[i])
                      executedChangeMethod = 1
                    }
                  }
                  if (this.company.delivery_options_labels[i].key === 'meet_half') {
                    this.company.delivery_options_labels[i].active = false
                    this.company.delivery_options_labels[i].enabled = false
                    // this.company.delivery_options_labels[i].active = response2.data.half_way
                    // this.company.delivery_options_labels[i].enabled = response2.data.half_way_enabled
                  }
                  if (this.company.delivery_options_labels[i].key === 'eat_location') {
                    this.company.delivery_options_labels[i].active = false
                    this.company.delivery_options_labels[i].enabled = false
                    // this.company.delivery_options_labels[i].active = response2.data.reserve
                    // this.company.delivery_options_labels[i].enabled = response2.data.reserve_enabled
                  }
                }
              }
            })
            // this.availableLocations = this.company.locations_details
            if (response.data[0].lastDraftOrder) {
              this.cartToken = response.data[0].lastDraftOrder
            }
            // if (response.data[0].avatar) {
            //   response.data[0].imagelist = [{url: response.data[0].avatar}]
            // } else {
            //   response.data[0].imagelist = []
            // }
            // self.model = response.data[0]
            // self.model.locations = response.data[0].locations_formatted
            // self.$nextTick(function () {
            //   self.loading = false
            //   self.loadingReset = false
            // })
          }
        })
      },
      scrollToCurrent () {
        this.$nextTick(function () {
          let el = this.$el.getElementsByClassName('current')[0]
          if (el) {
            var container = this.$refs.tableContainerRef
            var table = this.$refs.detailsScrollTable.$el.querySelector('.el-table__body tbody')
            var position = 1

            for (var i = 0; i < table.children.length; i++) {
              if (table.children[i].classList.length > 1 && table.children[i].classList[1] === 'current') {
                if (i > 1) {
                  position = i
                }
              }
            }
            container.scrollTo({
              left: 0,
              top: el.clientHeight * position,
              behavior: 'smooth'
            })
          }
        })
      },
      getTheCart (id = null, refreshOrder = 0) {
        this.loading = false
        this.orderCui = ''
        let shoppingCartId = null
        if (this.cart && this.cart.shopping_cart_id) {
          shoppingCartId = this.cart.shopping_cart_id
        } else if (id) {
          shoppingCartId = id
        }
        var data = {
          token: this.$session.get('token'),
          shopping_cart_id: shoppingCartId,
          location: this.selectedLocation,
          method: this.activeMethod,
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/get-cart', 'GET', data, (response2) => {
          if (response2.status === true) {
            this.preventInfiniteLoopGetCart = 1
            this.cart = response2.data
            this.cartToken = response2.data.shopping_cart_id
            this.getPaymentProfile()
            // this.getGategories()
            this.getProducts()
            if (this.client && this.activeMethod === 'pick_up') {
              this.selectClient(this.client, null, true, false)
            }
          } else {
            if (this.preventInfiniteLoopGetCart) {
              this.preventInfiniteLoopGetCart = 0
              this.cart = null
              this.getTheCart(null)
            }
          }
        })
      },
      getPaymentProfile () {
        var data = {
          token: this.$session.get('token'),
          add_order: true,
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/paymentprofile', 'GET', data, (response) => {
          if (response.status === true) {
            this.payment_options = response.data.payment_options
            // this.cashIsAvailable = !!this.payment_options.filter(opt => opt.id === 'cash').length
            this.posIsAvailable = !!this.payment_options.filter(opt => opt.id === 'pos').length
            if (this.cashIsAvailable) {
              this.payMethod = 'cash'
            } else {
              this.payMethod = ''
            }
          }
        })
      },
      newText () {
        if (this.searchText.length >= 1) {
          this.showRemoveTextFromSearch = 1
        } else {
          this.showRemoveTextFromSearch = 0
        }
        if (!this.loading) {
          if (this.newTextTimeout) clearTimeout(this.newTextTimeout)
          this.newTextTimeout = setTimeout(() => {
            this.getProducts(null, this.searchText)
          }, 1000)
        }
      },
      deleteTextFromSearch () {
        this.searchText = ''
        this.showRemoveTextFromSearch = 0
        this.getProducts()
      },
      deleteTextFromClientSearch () {
        this.searchClient = ''
        this.existingClients = []
      },
      changeDeliveryStatus (statusUsed, deliveryType) {
        if (statusUsed === 'DELIVERED' && deliveryType === 'EAT_LOCATION') {
          statusUsed = 'reservedReady'
          return this.$t('ordersStatus.' + statusUsed)
        }
        if (statusUsed === 'DELIVERED' && deliveryType === 'PICK_UP') {
          statusUsed = 'completedReady'
          return this.$t('ordersStatus.' + statusUsed)
        }
        if (statusUsed === 'DELIVERED' && (deliveryType === 'MEET_HALF' || deliveryType === 'DELIVERY')) {
          statusUsed = 'deliveredReady'
          return this.$t('ordersStatus.' + statusUsed)
        }
        return this.$t('ordersStatus.' + statusUsed)
      },
      goFullScreen () {
        var element = document.querySelector('.ordersposContainer')
        if (this.isFullScreen) {
          document.exitFullscreen()
          this.isFullScreen = false
        } else {
          this.isFullScreen = true
          this.requestFullScreen(element)
        }
      },
      requestFullScreen (element) {
        // Supports most browsers and their versions.
        var requestMethod = element.requestFullScreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || element.msRequestFullScreen
        if (requestMethod) { // Native full screen.
          requestMethod.call(element)
        } else if (window.ActiveXObject && typeof window.ActiveXObject !== 'undefined') { // Older IE.
          var wscript = new ActiveXObject('WScript.Shell')
          if (wscript !== null) {
            wscript.SendKeys('{F11}')
          }
        }
      },
      searchBtn () {
        this.searchFilterShow = !this.searchFilterShow
        if (!this.searchFilterShow) {
          this.deleteTextFromSearch()
        } else {
          this.$nextTick(() => {
            this.$refs.searchText.focus()
          })
        }
      },
      // getGategories () {
      //   var data2 = {
      //     token: this.$session.get('token'),
      //     shopping_cart_id: this.cart.shopping_cart_id
      //   }
      //   this.apiRequest('/menu-links-extended', 'GET', data2, (response) => {
      //     if (response.status === true) {
      //       //
      //     }
      //   })
      // },
      getProducts (categoryID = null, search = null) {
        this.selectedCategory = categoryID
        this.loading = true
        var data2 = {
          with_cache: true,
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          location_id: this.selectedLocation,
          delivery_method: this.activeMethod
        }
        if (categoryID) {
          data2.category_id = categoryID
          this.searchText = ''
          // this.searchFilterShow = false
          this.showRemoveTextFromSearch = 0
        }
        if (search) {
          data2.search = search
        }
        this.apiRequest('/admin-order-products', 'GET', data2, (response) => {
          if (response.status === true) {
            this.category = response.data.categories
            this.products = response.data.products
            this.openAllProducts(response.data.products)
            if (!categoryID && !search) {
              this.selectedCategory = this.category[0].id
            }
            setTimeout(() => {
              this.checkScrollProductList()
              // wait for the doom
            }, 1)
            this.loading = false
          }
        })
      },
      openAllProducts (productsFromRequest) {
        if (productsFromRequest.length) {
          let timeTimeout = 0
          for (var i = 0; i < productsFromRequest.length; i++) {
            if (i > 30) {
              return 0
            }
            if (productsFromRequest[i]) {
              timeTimeout += 500
              this.getProductsForCache(productsFromRequest[i], timeTimeout)
            }
          }
        }
      },
      getProductsForCache (product, timeTimeout) {
        setTimeout(() => {
          this.openProduct(product, null, null, null, true)
        }, timeTimeout)
      },
      addProductDirectlyToCart (prod) {
        if (prod.has_product_options) {
          this.openProduct(prod, 0, 0, () => {
            // this.addToCart();
          })
        } else {
          this.openProduct(prod, 0, 1, () => {
            this.addToCart()
          })
        }
      },
      openProduct (prod, edit = null, noModal = null, callback = null, forCacheOnly = null) {
        var i = 0
        var data2 = {
          with_cache: true,
          token: this.$session.get('token'),
          from_admin: true
          // company_id: this.$session.get('selectedCompany'),
        }
        if (edit) {
          data2.with_cache = false
          data2.add_order = true
          data2.index = prod.index
          data2.shopping_cart_id = this.cart.shopping_cart_id
          if (this.isInEditMode) {
            data2.edit_order = true
          }
        }
        const extraParam = '?deliveryMethod=' + this.activeMethod + '&location=' + this.selectedLocation
        // const extraParam = this.restaurantId && this.productCartIndex ? `?index=${this.productCartIndex}&${shoppingCartIdParam}` : `?${shoppingCartIdParam}`
        this.apiRequest('product/' + prod.id + extraParam, 'GET', data2, (resp) => {
          if (!forCacheOnly) {
            this.currentProductInPopup = resp.data[0]
            if (edit) {
              this.currentProductInPopup.index = prod.index
              this.currentProductInPopup.product_options = this.currentProductInPopup.categories
              this.currentProductInPopup.in_edit = true
              this.currentProductInPopup.order_part_item_id = this.currentProductInPopup.order_part_item_id
              this.currentProductInPopup.kds_section_id = this.currentProductInPopup.kds_section_id
              this.currentProductInPopup.image_url = []
              this.currentProductInPopup.image_url[0] = {'url': this.currentProductInPopup.image}
              if (this.currentProductInPopup.product_options.length) {
                for (i = this.currentProductInPopup.product_options.length - 1; i >= 0; i--) {
                  this.currentProductInPopup.product_options[i].values = this.currentProductInPopup.product_options[i].options
                  this.currentProductInPopup.product_options[i].name = this.currentProductInPopup.product_options[i].title
                  this.currentProductInPopup.product_options[i].min_no = this.currentProductInPopup.product_options[i].min
                  this.currentProductInPopup.product_options[i].max_no = this.currentProductInPopup.product_options[i].max
                  if (this.currentProductInPopup.product_options[i].values.length) {
                    for (var j = this.currentProductInPopup.product_options[i].values.length - 1; j >= 0; j--) {
                      this.currentProductInPopup.product_options[i].values[j].label = this.currentProductInPopup.product_options[i].values[j].name
                      if (this.currentProductInPopup.product_options[i].type === 'radio') {
                        if (this.currentProductInPopup.product_options[i].values[j].checked) {
                          this.currentProductInPopup.product_options[i].checked = this.currentProductInPopup.product_options[i].values[j].id
                        }
                      }
                    }
                  }
                }
              }
            }
            // if (this.currentProductInPopup.product_options.length) {
            //   for (i = this.currentProductInPopup.product_options.length - 1; i >= 0; i--) {
            //     if (this.currentProductInPopup.product_options[i].required) {
            //       this.addToCartDisabled = true
            //     }
            //   }
            // }
            this.updateCategories()

            if (!noModal) {
              this.$modal.show('productModal')
            }
          }
          if (callback) {
            callback()
          }
        })
      },
      updateQuantity (prod, add) {
        if (prod.quantity >= 1) {
          if (add) {
            prod.quantity++
          } else {
            if (prod.quantity > 1) {
              prod.quantity--
            }
          }
        }
        this.updateCategories()
        // prod.price_details.price = (prod.price * prod.quantity).toFixed(2)
      },
      updateCategories () {
        var sumToBeAdded = 0
        if (this.currentProductInPopup.product_options.length) {
          for (var i = this.currentProductInPopup.product_options.length - 1; i >= 0; i--) {
            this.currentProductInPopup.product_options[i].optionsSelected = []
            if (this.currentProductInPopup.product_options[i].values.length) {
              for (var j = this.currentProductInPopup.product_options[i].values.length - 1; j >= 0; j--) {
                if (this.currentProductInPopup.product_options[i].type === 'radio') {
                  if (this.currentProductInPopup.product_options[i].checked === this.currentProductInPopup.product_options[i].values[j].id) {
                    sumToBeAdded += parseFloat(this.currentProductInPopup.product_options[i].values[j].price)
                    this.currentProductInPopup.product_options[i].optionsSelected[0] = this.currentProductInPopup.product_options[i].values[j].id
                    this.currentProductInPopup.product_options[i].values[j].checked = true
                  } else {
                    this.currentProductInPopup.product_options[i].values[j].checked = false
                  }
                }
                if (this.currentProductInPopup.product_options[i].type === 'checkbox' && this.currentProductInPopup.product_options[i].values[j].checked) {
                  sumToBeAdded += parseFloat(this.currentProductInPopup.product_options[i].values[j].price)
                }
                if (this.currentProductInPopup.product_options[i].type === 'checkbox') {
                  if (this.currentProductInPopup.product_options[i].values[j].checked) {
                    this.currentProductInPopup.product_options[i].optionsSelected.push(this.currentProductInPopup.product_options[i].values[j].id)
                  }
                }
                if (this.currentProductInPopup.product_options[i].type === 'upload') {
                  let asd = this.currentProductInPopup.product_options[i].values[j].id
                  if (this.$refs[asd] && this.$refs[asd][0] && this.$refs[asd][0].files && this.$refs[asd][0].files[0]) {
                    this.setImage(this.$refs[asd][0].files[0], i, j)
                    sumToBeAdded += parseFloat(this.currentProductInPopup.product_options[i].values[j].price)
                    this.currentProductInPopup.product_options[i].optionsSelected.push(this.currentProductInPopup.product_options[i].values[j].id)
                  } else {
                    // this.currentProductInPopup.product_options[i].values[j].checked = false
                  }
                  if (!(this.$refs[asd] && this.$refs[asd][0] && this.$refs[asd][0].files && this.$refs[asd][0].files[0]) && this.currentProductInPopup.product_options[i].values[j].checked) {
                    this.currentProductInPopup.product_options[i].optionsSelected.push(this.currentProductInPopup.product_options[i].values[j].id)
                  }
                  // if (this.currentProductInPopup.product_options[i].values[j].checked) {
                  //   this.currentProductInPopup.product_options[i].optionsSelected.push(this.currentProductInPopup.product_options[i].values[j].id)
                  // }
                }
                if (this.currentProductInPopup.product_options[i].values[j].checked) {
                  this.currentProductInPopup.product_options[i].values[j].checked = true
                } else {
                  this.currentProductInPopup.product_options[i].values[j].checked = false
                }
              }
            }
          }
        }
        this.currentProductInPopup.price_details.price = parseFloat(this.currentProductInPopup.price) * parseFloat(this.currentProductInPopup.quantity)
        this.currentProductInPopup.price_details.price = this.currentProductInPopup.price_details.price + (parseFloat(sumToBeAdded) * parseFloat(this.currentProductInPopup.quantity))
        this.currentProductInPopup.price_details.price = parseFloat(this.currentProductInPopup.price_details.price).toFixed(2)

        if (this.company.is_required_options_for_admin_order) {
          let verifyCart = 1
          if (this.currentProductInPopup.product_options.length) {
            for (i = this.currentProductInPopup.product_options.length - 1; i >= 0; i--) {
              if (this.currentProductInPopup.product_options[i].min_no) {
                if (!(parseInt(this.currentProductInPopup.product_options[i].min_no) <= this.currentProductInPopup.product_options[i].optionsSelected.length)) {
                  verifyCart = 0
                }
              }
              if (this.currentProductInPopup.product_options[i].max_no) {
                if (!(parseInt(this.currentProductInPopup.product_options[i].max_no) >= this.currentProductInPopup.product_options[i].optionsSelected.length)) {
                  verifyCart = 0
                }
              }
            }
          }
          if (verifyCart) {
            this.addToCartDisabled = false
          } else {
            this.addToCartDisabled = true
          }
        }
      },
      setImage (img, i, j) {
        let self = this
        this.getBase64(img).then(
          (base64enc) => {
            self.currentProductInPopup.product_options[i].values[j].checked = true
            self.currentProductInPopup.product_options[i].values[j].file = base64enc
            let cv = self.currentProductInPopup
            self.currentProductInPopup = null
            self.currentProductInPopup = cv
          })
      },
      removeImage (optionIdx, valuesIdx) {
        let asd = this.currentProductInPopup.product_options[optionIdx].values[valuesIdx].id
        this.$refs[asd][0].value = ''

        this.currentProductInPopup.product_options[optionIdx].values[valuesIdx].checked = false
        this.currentProductInPopup.product_options[optionIdx].values[valuesIdx].file = null

        this.updateCategories()
      },
      modificationsInCart () {
        if (!this.cart || !this.cart.myCart) {
          return
        }
        localStorage.setItem('order_for_' + this.$session.get('selectedCompany'), JSON.stringify(this.cart))
        if (this.cart.myCart.total_cart_price <= 0) {
          this.payMethod = 'free'
        } else if (this.payMethod === 'free') {
          if (this.cashIsAvailable) {
            this.payMethod = 'cash'
          } else {
            this.payMethod = ''
          }
        }
      },
      applyUpdateCartResponse (response, refreshIfIncomplete = true) {
        if (response && response.data && response.data.myCart) {
          this.cart = response.data
          this.modificationsInCart()
          return true
        }
        if (refreshIfIncomplete && this.cart && this.cart.shopping_cart_id) {
          this.getTheCart(this.cart.shopping_cart_id)
        }
        return false
      },
      addToCart () {
        this.currentProductInPopup.categories = this.currentProductInPopup.product_options
        // this.currentProductInPopup.categories.optionsSelected = this.currentProductInPopup.product_options
        for (var i = this.currentProductInPopup.categories.length - 1; i >= 0; i--) {
          this.currentProductInPopup.categories[i].options = this.currentProductInPopup.product_options[i].values
          for (var j = this.currentProductInPopup.categories[i].options.length - 1; j >= 0; j--) {
            this.currentProductInPopup.categories[i].options[j].name = this.currentProductInPopup.categories[i].options[j].name
          }
        }
        this.loadingAddRemoveRequest++
        var data2 = {
          token: this.$session.get('token'),
          action: 'add',
          add_order: true,
          edit_order: this.isInEditMode,
          company_id: this.$session.get('selectedCompany'),
          shopping_cart_id: this.cart.shopping_cart_id,
          product: this.currentProductInPopup
        }
        this.apiRequest('/update-cart', 'PUT', data2, (response) => {
          if (response.status === true) {
            // this.getTheCart()
            this.cart = response.data
            this.modificationsInCart()
          }
          this.loadingAddRemoveRequest--
        })
        this.$modal.hide('productModal')
      },
      editToCart () {
        this.currentProductInPopup.categories = this.currentProductInPopup.product_options
        // this.currentProductInPopup.categories.optionsSelected = this.currentProductInPopup.product_options
        for (var i = this.currentProductInPopup.categories.length - 1; i >= 0; i--) {
          this.currentProductInPopup.categories[i].options = this.currentProductInPopup.product_options[i].values
          for (var j = this.currentProductInPopup.categories[i].options.length - 1; j >= 0; j--) {
            this.currentProductInPopup.categories[i].options[j].name = this.currentProductInPopup.categories[i].options[j].label
          }
        }

        var data2 = {
          token: this.$session.get('token'),
          action: 'edit',
          add_order: true,
          edit_order: this.isInEditMode,
          company_id: this.$session.get('selectedCompany'),
          shopping_cart_id: this.cart.shopping_cart_id,
          product_cart_index: this.currentProductInPopup.index,
          products_need_deleted: true,
          product: this.currentProductInPopup
        }
        this.loadingAddRemoveRequest++
        this.apiRequest('/update-cart', 'PUT', data2, (response) => {
          if (response.status === true) {
            // this.getTheCart()
            this.cart = response.data
            this.modificationsInCart()
          }
          this.loadingAddRemoveRequest--
        })
        this.$modal.hide('productModal')
      },
      editToCartUpdateQuantity (quantity, productId, productIndex) {
        var data2 = {
          token: this.$session.get('token'),
          action: 'update_quantity',
          add_order: true,
          edit_order: this.isInEditMode,
          company_id: this.$session.get('selectedCompany'),
          shopping_cart_id: this.cart.shopping_cart_id,
          quantity: quantity,
          product_id: productId,
          product_index: productIndex,
          products_need_deleted: true
        }
        if (quantity >= 1) {
          this.loadingAddRemoveRequest++
          this.apiRequest('/update-cart', 'PUT', data2, (response) => {
            if (response.status === true) {
              // this.getTheCart()
              this.cart = response.data
              this.modificationsInCart()
            }
            this.loadingAddRemoveRequest--
          })
        }
      },
      modifyProduct (prod) {
        this.openProduct(prod, true)
      },
      changePrice () {
        swal({
          title: this.$t('addOrder.titlePopupPriceModify'),
          input: 'text',
          inputAttributes: {
            autocapitalize: 'off'
          },
          showCancelButton: true,
          confirmButtonText: this.$t('addOrder.btnPopup'),
          showLoaderOnConfirm: true,
          target: document.getElementById('mySwal2')
        }).then((val) => {
          this.currentProductInPopup.price_details.price = parseFloat(val) * this.currentProductInPopup.quantity
          this.currentProductInPopup.price = parseFloat(val)
          this.currentProductInPopup.edit_price = true
          // swal.hideLoading()
          swal.close()
        // }
        })
      },
      deleteProductPopup (prodId, index) {
        if (this.isInEditMode) {
          swal({
            text: this.$t('addOrder.areYouSureDelete'),
            type: 'question',
            showCancelButton: true,
            confirmButtonText: 'Yes'
          })
          .then((result) => {
            if (result) {
              this.deleteProduct(prodId, index)
            }
          })
        } else {
          this.deleteProduct(prodId, index)
        }
      },
      deleteProduct (prodId, index) {
        var data2 = {
          token: this.$session.get('token'),
          action: 'remove_product',
          add_order: true,
          edit_order: this.isInEditMode,
          product_id: prodId,
          product_index: index,
          company_id: this.$session.get('selectedCompany'),
          products_need_deleted: true,
          shopping_cart_id: this.cart.shopping_cart_id
        }
        this.loadingAddRemoveRequest++
        this.apiRequest('/update-cart', 'PUT', data2, (response) => {
          if (response.status === true) {
            this.cart = response.data
            this.modificationsInCart()
          }
          this.loadingAddRemoveRequest--
        })
      },
      emptyCart () {
        var data2 = {
          token: this.$session.get('token'),
          action: 'empty_order',
          add_order: true,
          company_id: this.$session.get('selectedCompany'),
          products_need_deleted: true,
          shopping_cart_id: this.cart.shopping_cart_id
        }
        this.loadingAddRemoveRequest++
        this.apiRequest('/update-cart', 'PUT', data2, (response) => {
          if (response.status === true) {
            this.cart = response.data
            this.modificationsInCart()
          }
          this.loadingAddRemoveRequest--
        })
      },
      openClientModal () {
        this.$modal.show('userModal')
        setTimeout(() => {
          this.$refs.clientIdRef.focus()
        }, 10)
      },
      openAdressModal () {
        setTimeout(() => {
          if (
            this.$session.get('selectedCompany') === 39 ||
            this.$session.get('selectedCompany') === 30
            ) {
            this.new_client = {}
            this.new_client.address_city = 'Oradea'
            this.new_client.address_county = 'Bihor'
          }
          if (this.$session.get('selectedCompany') === 109) {
            this.new_client = {}
            this.new_client.address_city = 'Drobeta-Turnu Severin'
            this.new_client.address_county = 'Mehedinti'
          }
          if (this.$session.get('selectedCompany') === 38) {
            this.new_client = {}
            this.new_client.address_city = 'Ștefăneștii de Jos'
            this.new_client.address_county = 'Bucuresti'
          }
        }, 10)
        this.$modal.show('adressModal')
      },
      selectClient (client, adress = null, $addPerOrder = false, $getCartAfter = true) {
        this.client = client
        if (this.client && this.client.phone !== '') {
          this.client_phone_is_empty = false
        } else {
          this.client_phone_is_empty = true
        }
        this.client.newAdress = null
        this.newAdress = false
        this.searchClient = ''
        this.existingClients = []
        this.existingPhones = []
        this.existingEmails = []
        this.existingNames = []
        this.existingNames2 = []
        this.existingId = []
        // this.$modal.hide('userModal')
        this.new_client = {}

        if ($addPerOrder) {
          if (adress) {
            this.client.address = adress
          } else {
            this.client.address = this.client.addresses[0]
          }
          var data2 = {
            token: this.$session.get('token'),
            order_from_admin: 1,
            for_user: this.client.id,
            chosen_restaurant_id: this.selectedLocation,
            shopping_cart_id: this.cart.shopping_cart_id,
            add_order: true,
            chosen_address: this.client.address,
            company_id: this.$session.get('selectedCompany'),
            save_address: false,
            phone: this.client.phone || null,
            type: this.activeMethod.toUpperCase()
          }
          if (this.activeMethod.toUpperCase() === 'EAT_LOCATION') {
            data2.how_many = this.how_many
          }
          this.apiRequest('/delivery-type', 'POST', data2, (response) => {
            if (response.status === true) {
              // this.cart = response.data
              if ($getCartAfter) {
                this.getTheCart()
              }
            } else {
              this.client = null
              if (response.errors) {
                swal({
                  title: '',
                  text: response.errors[Object.keys(response.errors)[0]],
                  type: 'error',
                  showConfirmButton: true,
                  target: document.getElementById('mySwal2'),
                  toast: true
                })
              }
            }
          })
        }
      },
      // addNewAdresss () {
      //   // this.client.newAdress = {
      //   //   'address_name': '',
      //   //   'street': '',
      //   //   'number': '',
      //   //   'apartment': '',
      //   //   'city': '',
      //   //   'state': ''
      //   // }
      //   Vue.set(this.client, 'newAdress', {
      //     'address_name': '',
      //     'street': '',
      //     'number': '',
      //     'apartment': '',
      //     'city': '',
      //     'state': ''
      //   })
      //   this.newAdress = true
      // },
      addNewClient () {
        this.client = null
        this.newAdress = false
        this.new_client = {}
        this.new_clientErrors = {
          'count': 0,
          'email': '',
          'phone': '',
          'firstname': '',
          'address_street': '',
          'address_number': '',
          'address_apartment': '',
          'address_city': '',
          'address_county': ''
        }
      },
      addClient () {
        this.new_clientErrors = {
          'count': 0,
          'email': '',
          'phone': '',
          'firstname': ''
        }
        var email = /\S+@\S+\.\S+/
        if (this.new_client.email && this.new_client.email !== '' && !email.test(this.new_client.email)) {
          this.new_clientErrors.email = 'red'
          this.new_clientErrors.count++
        }
        if (typeof (this.new_client.firstname) === 'undefined' || this.new_client.firstname === '') {
          // this.new_clientErrors.firstname = 'red'
          // this.new_clientErrors.count++
          this.new_client.firstname = ''
        }
        if (typeof (this.new_client.phone) === 'undefined' || this.new_client.phone === '') {
          this.new_clientErrors.phone = 'red'
          this.new_clientErrors.count++
        }
        if (this.new_clientErrors.count) {
          return
        }
        this.loading = true
        var data2 = {
          token: this.$session.get('token'),
          cartId: this.cartToken,
          email: this.new_client.email,
          firstname: this.new_client.firstname,
          lastname: this.new_client.lastname,
          phone: this.new_client.phone,
          birthdate: this.new_client.birthdate,
          gender: this.new_client.gender,
          add_account: this.new_client.add_account,
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/add-new-client', 'POST', data2, (response) => {
          if (response.status === true) {
            this.client = response.data.client
            // this.selectClient(response.data.client, null, true)
            this.$modal.hide('userModal')
          } else {
            let err = ''
            if (response.errors.code) {
              err = response.errors.code
            }
            // if (response.errors.notInRange) {
            //   err = this.$t('addOrder.adressNotInRange')
            // } else {
            //   err = this.$t('addOrder.adressNotCorect')
            // }
            swal({
              title: 'Error',
              text: err,
              type: 'error',
              showConfirmButton: true,
              target: document.getElementById('mySwal2'),
              toast: true
            })
          }
          this.loading = false
        })
      },
      saveClient () {
        this.loading = true
        var data2 = {
          token: this.$session.get('token'),
          cartId: this.cartToken,
          client: this.client,
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/add-client', 'POST', data2, (response) => {
          if (response.status === true) {
            this.client = response.data.client
            // this.selectClient(response.data.client, null, true)
            this.$modal.hide('userModal')
          } else {
            let err = 'error'
            // if (response.errors.notInRange) {
            //   err = this.$t('addOrder.adressNotInRange')
            // } else {
            //   err = this.$t('addOrder.adressNotCorect')
            // }
            swal({
              title: '',
              text: err,
              type: 'error',
              showConfirmButton: true,
              target: document.getElementById('mySwal2'),
              toast: true
            })
          }
          this.loading = false
        })
      },
      deleteAdress (adressId) {
        swal({
          text: this.$t('addOrder.areYouSureDelete'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Yes'
        })
        .then((result) => {
          this.loading = true
          var data = {
            token: this.$session.get('token'),
            add_order: true,
            client_id: this.client.id,
            company_id: this.$session.get('selectedCompany')
          }
          this.apiRequest('/address/' + adressId, 'DELETE', data, (response) => {
            if (response.status === true) {
              swal({
                title: '',
                text: this.$t('addOrder.adressDeleted'),
                type: 'success',
                showConfirmButton: true,
                target: document.getElementById('mySwal2'),
                toast: true
              })
              this.saveClient()
            } else {
              let err = 'error'
              swal({
                title: '',
                text: err,
                type: 'error',
                showConfirmButton: true,
                target: document.getElementById('mySwal2'),
                toast: true
              })
            }
            this.loading = false
          })
        })
      },
      selectAdress (adress) {
        this.loading = true
        this.new_clientErrors = {
          'count': 0,
          'address_street': '',
          'address_number': '',
          'address_apartment': '',
          'address_city': '',
          'address_county': ''
        }
        var data2 = {
          token: this.$session.get('token'),
          cart_id: this.cartToken,
          client_id: this.client.id,
          adress_id: adress.id,
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/select-address', 'POST', data2, (response) => {
          if (response.status === true) {
            this.selectClient(response.data.client, response.data.client.address, true)
            // this.$modal.hide('adressModal')
          } else {
            let err = ''
            if (response.errors.notInRange) {
              err = this.$t('addOrder.adressNotInRange')
            } else {
              err = this.$t('addOrder.adressNotCorect')
            }
            swal({
              title: '',
              text: err,
              type: 'error',
              showConfirmButton: true,
              target: document.getElementById('mySwal2'),
              toast: true
            })
          }
          this.loading = false
        })
      },
      addNewAdress () {
        this.newAdress = false
        this.client.address = null
        this.new_clientErrors = {
          'count': 0,
          'address_street': '',
          'address_number': '',
          'address_apartment': '',
          'address_city': '',
          'address_county': ''
        }
      },
      addAddress () {
        this.new_clientErrors = {
          'count': 0,
          'address_street': '',
          'address_number': '',
          'address_apartment': '',
          'address_city': '',
          'address_county': ''
        }
        if (this.activeMethod === 'delivery') {
          if (typeof (this.new_client.address_street) === 'undefined' || this.new_client.address_street === '') {
            this.new_clientErrors.address_street = 'red'
            this.new_clientErrors.count++
          }
          if (typeof (this.new_client.address_number) === 'undefined' || this.new_client.address_number === '') {
            this.new_clientErrors.address_number = 'red'
            this.new_clientErrors.count++
          }
          if (typeof (this.new_client.address_apartment) === 'undefined' || this.new_client.address_apartment === '') {
            this.new_clientErrors.address_apartment = 'red'
            this.new_clientErrors.count++
          }
          if (typeof (this.new_client.address_city) === 'undefined' || this.new_client.address_city === '') {
            this.new_clientErrors.address_city = 'red'
            this.new_clientErrors.count++
          }
          if (typeof (this.new_client.address_county) === 'undefined' || this.new_client.address_county === '') {
            this.new_clientErrors.address_county = 'red'
            this.new_clientErrors.count++
          }
        }
        if (this.new_clientErrors.count) {
          return
        }
        this.loading = true
        var data2 = {
          token: this.$session.get('token'),
          cart_id: this.cartToken,
          client_id: this.client.id,
          address_street: this.new_client.address_street,
          address_number: this.new_client.address_number,
          address_county: this.new_client.address_county,
          address_city: this.new_client.address_city,
          address_apartment: this.new_client.address_apartment,
          address_name: this.new_client.address_name,
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/add-new-adress', 'POST', data2, (response) => {
          if (response.status === true) {
            this.client = response.data.client
            this.selectClient(response.data.client, response.data.client.address, true)
            this.$modal.hide('adressModal')
          } else {
            let err = ''
            if (response.errors.notInRange) {
              err = this.$t('addOrder.adressNotInRange')
            } else {
              err = this.$t('addOrder.adressNotCorect')
            }
            swal({
              title: '',
              text: err,
              type: 'error',
              showConfirmButton: true,
              target: document.getElementById('mySwal2'),
              toast: true
            })
          }
          this.loading = false
        })
      },
      editAddress () {
        this.loading = true
        var data2 = {
          token: this.$session.get('token'),
          cart_id: this.cartToken,
          client: this.client,
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/edit-adress', 'POST', data2, (response) => {
          if (response.status === true) {
            this.client = response.data.client
            this.selectClient(response.data.client, response.data.client.address, true)
            this.$modal.hide('adressModal')
          } else {
            let err = ''
            if (response.errors.notInRange) {
              err = this.$t('addOrder.adressNotInRange')
            } else {
              err = this.$t('addOrder.adressNotCorect')
            }
            swal({
              title: '',
              text: err,
              type: 'error',
              showConfirmButton: true,
              target: document.getElementById('mySwal2'),
              toast: true
            })
          }
          this.loading = false
        })
      },
      searchForClient () {
        if (this.not2timeSsearchForClient) {
          if (this.searchClient === '') {
            this.existingClients = []
          } else {
            this.existingPhones = []
            this.existingEmails = []
            this.existingNames = []
            this.existingNames2 = []
            this.existingId = []
            this.not2timeSsearchForClient = 0
            setTimeout(() => {
              var data2 = {
                search: this.searchClient,
                token: this.$session.get('token'),
                company_id: this.$session.get('selectedCompany')
              }
              this.apiRequest('/search-for-client', 'GET', data2, (response) => {
                if (response.status === true) {
                  this.existingClients = response.data.clients
                  // this.loading = false
                }
                this.not2timeSsearchForClient = 1
              })
            }, 500)
          }
        }
      },
      autocompletePhone () {
        var dataToBeSent = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        if (this.supraSelectedLocation && this.selectedLocation) {
          dataToBeSent.location_token = this.selectedLocation
        }
        this.apiRequest('/autocomplete-phone', 'GET', dataToBeSent, (response) => {
          if (response.status === true) {
            if (response.data.clients.length === 1) {
              this.selectClient(response.data.clients[0])
            } else {
              this.existingPhones = response.data.clients
              this.new_client.phone = response.data.phone
            }
            // this.loading = false
          }
          this.not2timeByPhone = 1
        })
      },
      searchByPhone () {
        if (this.not2timeByPhone) {
          if (this.new_client.phone === '') {
            this.existingPhones = []
          } else {
            this.not2timeByPhone = 0
            this.existingClients = []
            this.existingEmails = []
            this.existingNames = []
            this.existingNames2 = []
            this.existingId = []
            setTimeout(() => {
              var data2 = {
                search: this.new_client.phone,
                token: this.$session.get('token'),
                company_id: this.$session.get('selectedCompany')
              }
              this.apiRequest('/search-by-phone', 'GET', data2, (response) => {
                if (response.status === true) {
                  this.existingPhones = response.data.clients
                  // this.loading = false
                }
                this.not2timeByPhone = 1
              })
            }, 500)
          }
        }
      },
      searchByEmail () {
        if (this.not2timeByEmail) {
          if (this.new_client.email === '') {
            this.existingEmails = []
          } else {
            this.not2timeByEmail = 0
            this.existingClients = []
            this.existingPhones = []
            this.existingNames = []
            this.existingNames2 = []
            this.existingId = []
            setTimeout(() => {
              var data2 = {
                search: this.new_client.email,
                token: this.$session.get('token'),
                company_id: this.$session.get('selectedCompany')
              }
              this.apiRequest('/search-by-email', 'GET', data2, (response) => {
                if (response.status === true) {
                  this.existingEmails = response.data.clients
                  // this.loading = false
                }
                this.not2timeByEmail = 1
              })
            }, 500)
          }
        }
      },
      searchByName () {
        if (this.not2timeByName) {
          if (this.new_client.firstname === '') {
            this.existingNames = []
          } else {
            this.not2timeByName = 0
            this.existingClients = []
            this.existingPhones = []
            this.existingEmails = []
            this.existingNames2 = []
            this.existingId = []
            setTimeout(() => {
              var data2 = {
                search: this.new_client.firstname,
                token: this.$session.get('token'),
                company_id: this.$session.get('selectedCompany')
              }
              this.apiRequest('/search-by-firstname', 'GET', data2, (response) => {
                if (response.status === true) {
                  this.existingNames = response.data.clients
                  // this.loading = false
                }
                this.not2timeByName = 1
              })
            }, 500)
          }
        }
      },
      searchByName2 () {
        if (this.not2timeByName2) {
          if (this.new_client.lastname === '') {
            this.existingNames2 = []
          } else {
            this.not2timeByName2 = 0
            this.existingClients = []
            this.existingPhones = []
            this.existingEmails = []
            this.existingNames = []
            this.existingId = []
            setTimeout(() => {
              var data2 = {
                search: this.new_client.lastname,
                token: this.$session.get('token'),
                company_id: this.$session.get('selectedCompany')
              }
              this.apiRequest('/search-by-lastname', 'GET', data2, (response) => {
                if (response.status === true) {
                  this.existingNames2 = response.data.clients
                  // this.loading = false
                }
                this.not2timeByName2 = 1
              })
            }, 500)
          }
        }
      },
      searchById (event) {
        if (event.keyCode === 13) {
          this.searchByIdPressEnter = 1
        }
        if (this.not2timeById) {
          if (this.new_client.lastname === '') {
            this.existingId = []
          } else {
            this.not2timeById = 0
            this.existingClients = []
            this.existingPhones = []
            this.existingEmails = []
            this.existingNames = []
            this.existingNames2 = []
            setTimeout(() => {
              var data2 = {
                search: this.new_client.id,
                token: this.$session.get('token'),
                company_id: this.$session.get('selectedCompany')
              }
              this.apiRequest('/search-by-id', 'GET', data2, (response) => {
                if (response.status === true) {
                  this.existingId = response.data.clients
                  // this.loading = false

                  if (this.searchByIdPressEnter && this.existingId.length) {
                    this.selectClient(this.existingId[0])
                  }
                  this.searchByIdPressEnter = 0
                }
                this.not2timeById = 1
              })
            }, 500)
          }
        }
      },
      changeMethod (method) {
        this.category = {}
        this.products = {}
        if (!this.supraSelectedLocation) {
          this.selectedLocation = null
        }
        this.availableLocations = []
        this.client.address = null
        // for (var i = this.availableLocations.length - 1; i >= 0; i--) {
        //   for (var j = this.availableLocations[i].ordering_management.length - 1; j >= 0; j--) {
        //     if (this.availableLocations[i].ordering_management[j].type === method.key) {
        //       if (this.availableLocations[i].ordering_management[j].enabled) {
        //         this.availableLocations[i].notShow = false
        //       } else {
        //         this.availableLocations[i].notShow = true
        //         if (this.selectedLocation === this.availableLocations[i].id) {
        //           this.selectedLocation = null
        //         }
        //       }
        //     }
        //   }
        // }
        let newMethod = method.key
        if (newMethod === 'pick_up') {
          newMethod = 'pickup'
        }
        if (newMethod === 'meet_half') {
          newMethod = 'half_way'
        }
        if (newMethod === 'eat_location') {
          newMethod = 'reserve'
        }
        var data2 = {
          token: this.$session.get('token'),
          add_order: true,
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('delivery-type-details/' + newMethod, 'GET', data2, (response) => {
          if (response.status === true) {
            this.activeMethod = method.key
            this.availableLocations = response.data.restaurants
            // this.dropdownLocationActive = true
            setTimeout(() => {
              this.selectedLocationChanged(response.data.restaurants[0])
            }, 10)
          }
        })
      },
      selectedLocationChanged (loc) {
        this.dropdownLocationActive = false
        if (!this.supraSelectedLocation) {
          this.selectedLocation = loc.id
        }
        this.category = {}
        this.products = {}
        this.client.address = null
        if (this.selectedLocation) {
          // this.getTheCart(this.cartToken)
          this.getTheCart(null)
          // this.curentLocation = this.availableLocations.filter(obj => { return obj.id === this.selectedLocation })
          // if (this.curentLocation && this.curentLocation.length) {
          //   this.curentLocation = this.curentLocation[0]
          // }
          // if (this.activeMethod === 'delivery') {
          //   this.$modal.show('adressModal')
          // }
        }
        if (this.availableLocations.length) {
          this.curentLocation = loc
          // this.curentLocation = this.availableLocations.filter(obj => { return obj.id === this.selectedLocation })
          if (this.curentLocation && this.curentLocation.length) {
            this.curentLocation = this.curentLocation[0]
          }
          if ((this.curentLocation.offset === '0' && this.curentLocation.period === '1') ||
              (this.curentLocation.offset === 0 && this.curentLocation.period === 1)) {
            this.noDate = 1
            this.choosenHours = this.curentLocation.available_hours_today
            this.selectedHour = this.curentLocation.available_hours_today[0]
          } else {
            this.noDate = 0
          }
          if ((this.curentLocation.hour_and_date_delivery_hour_usage && !this.noDate) || this.curentLocation.just_date_delivery_hour_usage) {
            const startSplit = this.curentLocation.period_range.start_day.split('-')
            const startSplitDay = startSplit[0].substring(0, 1) === '0' ? startSplit[0].substring(1, 2) : startSplit[0]
            const startSplitMounth = startSplit[1].substring(0, 1) === '0' ? startSplit[1].substring(1, 2) : startSplit[1]
            const startSplitYear = startSplit[2]
            const getStart = `${startSplitYear}/${startSplitMounth}/${startSplitDay}`
            const startParsedData = new Date(getStart)
            let dayIndex = new Date(startParsedData).getDay()
            this.selectedDate = startParsedData
            this.choosenHours = this.curentLocation.available_hours[dayIndex]
            this.selectedHour = this.curentLocation.available_hours[dayIndex][0]
          }
          if (this.curentLocation.offset === '0' && this.isToday(this.selectedDate)) {
            this.choosenHours = this.curentLocation.available_hours_today
            this.selectedHour = this.curentLocation.available_hours_today[0]
          }
          if (this.curentLocation.just_date_delivery_hour_usage) {
            this.selectedHour = null
          }
          if (this.curentLocation.deactivate_delivery_hour_usage) {
            this.selectedHour = null
            this.selectedDate = null
          }
        }
      },
      filterForstatusEntered () {
        var data2 = {
          token: this.$session.get('token'),
          add_order: true,
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('pos-statuses', 'GET', data2, (response) => {
          if (response.status === true) {
            this.availableStatuses = response.data.statuses
          }
          if (
              this.$session.get('selectedCompany') === 136 ||
              this.$session.get('selectedCompany') === 125 ||
              this.$session.get('selectedCompany') === 201 ||
              this.$session.get('selectedCompany') === 210 ||
              this.$session.get('selectedCompany') === 233 ||
              this.$session.get('selectedCompany') === 234 ||
              this.$session.get('selectedCompany') === 238
            ) {
            this.availableStatuses.PROCESSING = true
            this.selectedStatus = 'PROCESSING'
          }
          if (this.availableStatuses.DELIVERED) {
            this.selectedStatus = 'DELIVERED'
          }
        })
      },
      isToday (someDate) {
        if (someDate) {
          const today = new Date()
          return someDate.getDate() === today.getDate() &&
            someDate.getMonth() === today.getMonth() &&
            someDate.getFullYear() === today.getFullYear()
        } else {
          return false
        }
      },
      openHourDate () {
        this.$modal.show('hourDateModal')
      },
      addOrRemoveTip (flag) {
        if (flag) {
          swal({
            title: this.$t('addOrder.titlePopupTip'),
            input: 'number',
            inputAttributes: {
              autocapitalize: 'off'
            },
            showCancelButton: true,
            confirmButtonText: this.$t('addOrder.btnPopup'),
            showLoaderOnConfirm: true,
            target: document.getElementById('mySwal2'),
            preConfirm: (val) => {
              this.setTip(val, (response) => {
                if (response.status === true) {
                  swal.close()
                }
                swal.hideLoading()
              })
            }
            // allowOutsideClick: () => !swal.isLoading()
          })
        } else {
          this.setTip(0)
        }
      },
      setTip (tipValue, callback = null) {
        var data2 = {
          token: this.$session.get('token'),
          action: 'set_tip',
          add_order: true,
          tip_value: tipValue || 0,
          company_id: this.$session.get('selectedCompany'),
          products_need_deleted: true,
          shopping_cart_id: this.cart.shopping_cart_id
        }
        this.apiRequest('/update-cart', 'PUT', data2, (response) => {
          if (response.status === true) {
            this.cart = response.data
            this.modificationsInCart()
          }
          if (callback) {
            callback(response)
          }
        })
      },
      useOrRemoveLoyaltyPoints (flag) {
        var data = {
          token: this.$session.get('token'),
          action: 'use_loyalty_points',
          status: !this.cart.loyalty_discount_value,
          add_order: true,
          company_id: this.$session.get('selectedCompany'),
          products_need_deleted: true,
          shopping_cart_id: this.cart.shopping_cart_id
        }
        this.apiRequest('/update-cart', 'PUT', data, (response) => {
          if (response.status === true) {
            this.cart = response.data
            this.modificationsInCart()
          }
        })
      },
      toggleCommentSection () {
        this.showCommentSection = !this.showCommentSection
      },
      showFreeCouponProductsAdded (response) {
        const added = response.data_specials && response.data_specials.free_coupon_products_added
        if (!added || !added.length) {
          return
        }
        const productNames = added.map((item) => item.name || item.product_id).join(', ')
        swal({
          toast: true,
          position: 'bottom-start',
          showConfirmButton: false,
          timer: 4000,
          type: 'success',
          target: document.getElementById('mySwal2'),
          title: this.$t('addOrder.freeCouponProductAdded', { products: productNames })
        })
      },
      addOrRemoveCupon (flag) {
        if (flag) {
          swal({
            title: this.$t('addOrder.titlePopupCoupon'),
            input: 'text',
            inputAttributes: {
              autocapitalize: 'off'
            },
            showCancelButton: true,
            confirmButtonText: this.$t('addOrder.btnPopup'),
            showLoaderOnConfirm: true,
            target: document.getElementById('mySwal2'),
            preConfirm: (val) => {
              if (!val) {
                return Promise.reject(new Error(this.$t('validations.requiredField')))
              }
              var data2 = {
                token: this.$session.get('token'),
                action: 'use_coupon',
                add_order: true,
                apply_coupon: false,
                status: true,
                check_coupon: 'check_coupon',
                coupon: val,
                company_id: this.$session.get('selectedCompany'),
                products_need_deleted: true,
                shopping_cart_id: this.cart.shopping_cart_id
              }
              return new Promise((resolve, reject) => {
                this.apiRequest('/update-cart', 'PUT', data2, (response) => {
                  if (response.status === true) {
                    this.showFreeCouponProductsAdded(response)
                    this.applyUpdateCartResponse(response)
                    resolve()
                  } else if (response.errors && response.errors.wrong_coupon) {
                    reject(new Error(this.$t('addOrder.errorPopupCoupon')))
                  } else {
                    reject(new Error(this.$t('validations.wentWrong')))
                  }
                })
              })
            }
            // allowOutsideClick: () => !swal.isLoading()
          })
        } else {
          var data2 = {
            token: this.$session.get('token'),
            action: 'use_coupon',
            add_order: true,
            apply_coupon: true,
            status: false,
            coupon: '',
            company_id: this.$session.get('selectedCompany'),
            products_need_deleted: true,
            shopping_cart_id: this.cart.shopping_cart_id
          }
          this.apiRequest('/update-cart', 'PUT', data2, (response) => {
            if (response.status === true) {
              this.applyUpdateCartResponse(response)
            }
          })
        }
      },
      openPayModal () {
        this.$modal.show('payModal')
      },
      openCommentModal () {
        this.$modal.show('commentModal')
      },
      submitComment () {
        this.$modal.hide('commentModal')
      },
      printOrders () {
        console.log('print')
        var data = {
          token: this.$session.get('token')
        }
        this.apiRequest('/noauth/print/orders', 'GET', data, (response) => {
          if (response.status === true) {
            console.log('Răspunsul de la server:', response)
          } else {
            console.error('Eroare la procesarea comenzii', response)
          }
        })
      },
      others () {
        swal({
          title: this.$t('addOrder.other'),
          html: `
            <button id="reportX" class="orderWithPaymentButton orange">Raport X</button>
            <button id="reportZ" class="orderWithPaymentButton orange">Raport Z</button>
          `,
          showCancelButton: true,
          showConfirmButton: false,
          cancelButtonText: this.$t('cancel'),
          cancelButtonClass: 'swal-button--danger'
        })

        // Adăugăm evenimente pentru butoanele Raport X și Raport Z
        document.getElementById('reportX').addEventListener('click', () => {
          this.generateRaport('X')
          swal.close()
        })
        document.getElementById('reportZ').addEventListener('click', () => {
          this.generateRaport('Z')
          swal.close()
        })
      }
    }
  }
</script>
<style scoped lang="scss">
  .floatBox {
    position: absolute;
    bottom: 0;
    right: 0;
    // bottom: 25px;
    // right: 270px;
    // width: 200px;
    // height: 80px;
    z-index: 999;
    // background: black;
    color: #25396F;
    padding: 10px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .badge_wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .badge {
      margin-right: 10px;
      position: relative;
      width: 20px;
      height: 20px;
      border-radius: 100%;
      background-color: #20c598;
      span {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        margin: 0 !important;
      }
    }
  }
  .statuses,
  .adress,
  .loc,
  .method_btns,
  .client {
    >span {
      margin: 0;
      font-weight: 600;
    }
  }
  .goToClient {
    width: auto;
    color: #fff;
    background: #674bd2;
    display: inline-block;
    border: 0;
    padding: 10px 20px;
    margin: 0;
    font-weight: 500;
    border-radius: 14px;
  }
  .buttonWithSearch {
    position: relative;
    overflow: visible;
    width: 100%;
    margin: 0px 10px;
    button {
      width: 100%;
      height: 60px;
      color: #909090;
      background: #ECECEC;
      border: 0;
      padding: 10px 15px;
      border-radius: 10px;
      font-weight: 500;
      &:disabled {
        opacity: 0.5;
      }
      &.active {
        color: #fff;
        background: #674BD2;
      }
    }
    .buttonWithSearch_search {
      width: 100%;
      position: absolute;
      left: 0;
      top: 100%;
      z-index: 9;
      background: #fff;
      border: 1px solid #E4E8F9;
      border-radius: 10px;
      padding: 5px 20px;
      max-height: 300px;
      overflow: auto;
      padding: 0;
      cursor: pointer;
      transition: 0.5s;
      .searchList {
        padding: 10px 20px;
        border-bottom: 1px solid #DCDCDC;
        &:hover {
          transition: 0.5s;
          background: #674bd2;
          color: #fff;
        }
        &:last-of-type {
          border: 0;
        }
      }
    }
  }
  .inputWithSearch {
    position: relative;
    overflow: visible;
    width: calc(50% - 10px);
    input {
      width: 100% !important;
    }
    .autoPhone {
      border: 1px solid #eee;
      border-radius: 10px;
      background: #20C598;
      color: #fff;
      margin-left: 10px;
    }
    .inputWithSearch_search {
      width: 100%;
      position: absolute;
      left: 0;
      top: calc(100% - 21px);
      z-index: 3;
      background: #fff;
      border: 1px solid #E4E8F9;
      border-radius: 10px;
      padding: 5px 20px;
      max-height: 300px;
      overflow: auto;
      padding: 0;
      .client {
        padding: 10px 20px;
        border-bottom: 1px solid #DCDCDC;
        &:last-of-type {
          border: 0;
        }
      }
    }
  }
  .ordersposContainer{
    padding: 10px;
    margin: 0;
  }
  .orderspos {
    width: 100%;
    height: 100%;
    background: transparent;
    border-radius: 10px;
    padding: 10px;
  }
  .statuses {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .buttonWithSearch {
      width: 100%;
      button {
        border: 0;
        padding: 10px;
        border-radius: 5px;
        font-weight: 500;
        height: auto;
        min-height: 50px;
      }
    }
  }
  .middleSection {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    height: calc(100%);
    .cartDetail_wrapper,
    .productList_wrapper {
      width: 100%;
      height: 100%;
      position: relative;
      display: flex;
      &.disabled {
        opacity: 0.3;
        user-select: none;
        pointer-events: none;
      }
    }
    .productList_wrapper {
      height: calc(100% - 130px);
      background: #fff;
      border-radius: 10px;
      padding-bottom: 10px;
      .productList_wrapper_left {
        position: relative;
        width: 20%;
        display: flex;
        flex-direction: column;
        align-items: stretch;
        padding-left: 0px;
        padding-right: 0px;
        .productList_filter {
          height: 60px;
          min-height: 60px;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          padding-left: 10px;
          h3 {
            margin: 0;
            font-size: 24px;
          }
        }
      }
      .productList_wrapper_right {
        width: 80%;
        display: flex;
        flex-direction: column;
        align-items: stretch;
        padding-left: 10px;
        padding-right: 10px;
        border-radius: 14px;
        background: #F4F6FF;
        .productList_topBar {
          height: 60px;
          >h3 {
            margin: 0;
            margin-left: 10px;
            font-size: 24px;
          }
          display: flex;
          align-items: center;
          justify-content: space-between;
          .search_wrapper {
            display: flex;
            flex-direction: row;
          }
          .searchBtn {
            display: flex;
            align-items: center;
            justify-content: center;
            pointer-events: all;
            cursor: pointer;
            z-index: 2;
            margin-top: 5px;
            margin-left: 1px;
            .circle {
              width: 40px;
              height: 40px;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 100%;
              background: #ECECEC;
              margin-bottom: 10px;
              &:hover {
                background: #674BD2;
                svg {
                  color: #fff;
                  fill: #fff;
                  * {
                    stroke: #fff;
                  }
                }
              }
              &.used {
                background: #674BD2;
                svg * {
                  stroke: #fff;
                  color: #fff;
                  fill: #fff;
                }
              }
              svg {
                margin: 0;
                width: 20px;
                color: #777777;
                fill: #777777;
                * {
                  stroke: #777777;
                }
              }
            }
            // svg {
            //   margin-bottom: 10px;
            //   @media screen and (max-width: 1800px) {
            //     width: 50px;
            //     height: 50px;
            //   }
            //   @media screen and (max-width: 1300px) {
            //     width: 40px;
            //     height: 40px;
            //   }
            // }
          }
          .filter__search {
            width: calc(100% - 20px);
            display: none;
            align-items: center;
            justify-content: flex-start;
            background: #F4F6FF;
            margin-left: 20px;
            &.showw {
              display: flex;
            }
            .search {
              position: relative;
              width: 100%;
              margin-top: 0;
              margin-bottom: 0;
              background: #F4F6FF;
              input {
                width: 100%;
                height: 40px;
                padding-left: 60px;
                padding-right: 50px;
                background: #FFFFFF;
                border-radius: 40px;
                border: 1px solid #CAD6F3;
              }
              .icosearch {
                height: 24px;
                position: absolute;
                left: 20px;
                top: calc(50% - 12px);
                svg {
                  width: auto;
                  height: 100%;
                }
              }
              .closeSearch {
                height: 22px;
                position: absolute;
                right: 20px;
                top: calc(50% - 11px);
                opacity: 0;
                transition: 0.5s;
                &.show {
                  opacity: 1;
                  transition: 0.5s;
                }
                svg {
                  width: auto;
                  height: 100%;
                }
              }
            }
          }
        }
      }
    }
    .cartDetail_wrapper {
      flex-direction: column;
      height: calc(100% - 65px);
      margin-top: 0px;
      > .settings {
        display: flex;
        background: #fff;
        gap: 30px;
        padding: 10px 20px;
        padding-bottom: 0px;
        .commentOrder,
        .settings {
          cursor: pointer;
        }
      }
    }
    .leftPart {
      width: calc(65% - 10px);
      margin-right: 10px;
      height: 100%;
      position: relative;
      .filter {
        width: 100%;
        height: calc(100% - 60px);
        display: flex;
        flex-direction: column;
        padding: 10px;
        .filter__bar {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          flex-direction: column;
          a {
            margin-bottom: 10px;
            width: 100%;
            background-position: center;
            background-size: cover;
            background-color: transparent;
            background-repeat: no-repeat;
            border-radius: 17px;
          }
          .selected {
            button {
              background: rgba(103, 75, 210, 0.5);
              color: #fff;
              transition: 0.5s;
            }
          }
          button {
            height: 100%;
            width: 100%;
            color: #25396F;
            background: #E6E6FF;
            border: 0;
            padding: 10px 15px;
            border-radius: 16px;
            font-weight: 500;
            transition: 0.5s;
            @media screen and (max-width: 1400px) {
              padding: 8px 10px;
              font-size: 12px;
            }
            @media screen and (max-width: 1300px) {
              padding: 5px 8px;
            }
            &:hover {
              background: rgba(103, 75, 210, 0.5);
              color: #fff;
              transition: 0.5s;
            }
          }
          .filter__cat {
            display: flex;
            align-items: stretch;
            flex-wrap: wrap;
            height: 100%;
            overflow: auto;
            padding-right: 10px;
          }
          .filter__cat::-webkit-scrollbar {
              width: 20px;
          }
          .filter__cat::-webkit-scrollbar-thumb {
              border-radius: 100px;
              border: 5px solid transparent;
              background-clip: content-box;
              background-color: #674BD2;
          }
          .filter__cat::-webkit-scrollbar-track {
              background-color: #e4e4e4;
              border-radius: 100px;
          }
        }
      }
    }
    .rightPart {
      margin-left: 10px;
      width: calc(35% - 10px);
      height: 100%;
      padding: 10px 0px;
      padding-top: 0px;
      position: relative;
      color: #25396F;
      border-radius: 10px;
      position: relative;
      // background-image: url('/static/img/background/bg.png');
      background-repeat: no-repeat;
      background-size: contain;
      background-color: #E4E8F9;
      padding-top: 0px;
      padding-bottom: 0px;
      background-position: top;
      .orderDetails_title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 20px;
        height: 65px;
        background: #CAD6F3;
        border-radius: 10px;
        p {
          margin: 0;
          font-size: 22px;
        }
      }
      p {
        margin: 0;
        // margin-bottom: 10px;
        font-size: 18px;
        font-weight: 500;
        @media screen and (max-width: 1800px) {
          font-size: 18px;
        }
        @media screen and (max-width: 1300px) {
          font-size: 14px;
        }
      }
      .settings-box {
        display: flex;
        justify-content: center;
        align-items: center;
        .commentOrder {
          margin: 0 20px;
          cursor: pointer;
        }
        .settings {
          margin: 0 20px;
          cursor: pointer;
        }
      }
      .statusAndHour {
        .buttonWithSearch {
        }
      }
      .hour {
        padding-right: 70px;
        .openHourDateBtn {
          background: #E6E6FF;
          border: 1px solid #CAD6F3;
          width: 100%;
          border-radius: 14px;
          padding: 13px;
          color: #674BD2;
        }
      }
      .location {
        padding: 10px 0px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .allLocations {
          max-height: 70px;
          overflow: auto;
          .oneLocation {
            display: flex;
            align-items: center;
            justify-content: space-between;
            label {
              display: flex;
              align-items: center;
              justify-content: space-between;
              input {
                width: 17px;
                height: 17px;
                margin: 0;
                margin-right: 10px;
              }
            }
            span {
              font-size: 20px;
              font-weight: normal;
            }
            .oneLocation__adress {
              font-size: 16px;
              color: #25396F;
            }
          }
        }
      }
      .total-box {
        padding: 20px 20px;
        padding-bottom: 0px;
        background: #fff;
        position: absolute;
        bottom: 0;
        width: 100%;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
        border-top: 1px solid #CAD6F3;
        border-top-left-radius: 30px;
        border-top-right-radius: 30px;
      }
      .box-com {
        padding: 0px 20px;
        background: #E4E8F9;
      }
      .client {
        background: #E4E8F9;
        margin-top: 5px;
      }
      .cartDetail {
        padding: 10px 20px;
        background: #fff;
        border-bottom-left-radius: 14px;
        border-bottom-right-radius: 14px;
        padding-top: 0px;
        // position: relative;
        // top: 10px;
        .cartDetail__head {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding-bottom: 10px;
          padding-top: 5px;
        }
        .emptyCart {
          margin-left: 20px;
          color: #FF0D19;
          background: #FFEBEA;
          border: 0;
          border-radius: 10px;
          width: 35px;
          height: 35px;
          font-size: 20px;
          font-weight: 500;
          svg {
            width: 16px;
          }
        }
        .products {
          max-height: 500px;
          overflow: auto;
          font-size: 18px;
          padding-bottom: 40px;
          .noProducts {
            display: flex;
            flex-direction: column;
            align-items: center;
            p {
              max-width: 300px;
              margin: auto;
              text-align: center;
            }
          }
          .product {
            border-bottom: 1px solid #CAD6F3;
            padding: 12px 0px;
            > span {
              margin-bottom: 12px;
              display: block;
            }
          }
          &.big{
            max-height: 630px;
          }
          &.heightbig {
            max-height: 630px;
          }
        }
        .product {
          @media screen and (max-width: 1800px) {
            font-size: 14px;
          }
          @media screen and (max-width: 1300px) {
            font-size: 12px;
          }
          .product_wrapper {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .product_right {
              display: flex;
              align-items: center;
              justify-content: flex-start;
              font-size: 16px;
              @media screen and (max-width: 1800px) {
                font-size: 14px;
              }
              @media screen and (max-width: 1300px) {
                font-size: 12px;
              }
              .product__delete {
                margin-left: 20px;
                color: #FF0D19;
                background: #FFEBEA;
                border: 0;
                border-radius: 100%;
                width: 40px;
                height: 40px;
                font-size: 20px;
                font-weight: 500;
                @media screen and (max-width: 1300px) {
                  font-size: 14px;
                  width: 24px;
                  height: 24px;
                }
              }
              .product__modify {
                margin-left: 20px;
                color: #fff;
                background: #0099FF;
                padding: 10px 22px;
                border: 0;
                border-radius: 20px;
                text-transform: uppercase;
                font-size: 14px;
                @media screen and (max-width: 1800px) {
                  padding: 8px 15px;
                }
                @media screen and (max-width: 1300px) {
                  font-size: 12px;
                  padding: 5px 8px;
                }
              }
            }
          }
        }
      }
      .buttons {
        display: flex;
        align-items: stretch;
        justify-content: space-between;
        flex-direction: row;
        width: 100%;
        height: auto;
        overflow: auto;
        gap: 5px;
        @media screen and (max-width: 1300px) {
          height: auto;
        }
        button {
          width: calc(43.33% - 10px);
          padding: 10px 10px;
          // margin-bottom: 20px;
          border: 0;
          font-size: 14px;
          @media screen and (max-width: 1800px) {
            font-size: 13px;
            padding: 1px 1px;
          }
          @media screen and (max-width: 1300px) {
            font-size: 12px;
            padding: 1px 1px;
          }
        }
        .discount {
          background: #FFF6DB;
          color: #E5AB09;
          border: 1px solid #E5AB09;
          border-radius: 10px;
        }
        .loyalty_points {
          background: #FBEEEC;
          color: #EA7867;
          border: 1px solid #EA7867;
          border-radius: 10px;
        }
        .tips {
          background: #efeefb;
          color: #676bea;
          margin-bottom: 0;
          border: 1px solid #676bea;
          border-radius: 10px;
        }
      }
      .bottomPart {
        display: flex;
        align-items: stretch;
        justify-content: space-between;
        padding: 10px 0;
        .textAndBtns {
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          // height: 240px;
          @media screen and (max-width: 1800px) {
            // height: 155px;
          }
          @media screen and (max-width: 1300px) {
            // height: 130px;
          }
          .textarea {
            width: 100%;
            textarea {
              resize: none;
              width: 100%;
              height: 65px;
              padding: 5px 10px;
              border: 1px solid #CAD6F3;
              border-radius: 14px;
              &:focus,
              &:focus-visible {
                  outline: 0;
              }
              @media screen and (max-width: 1300px) {
                max-height: 80px;
              }
            }
          }
        }
      }
      .payMethod {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        button {
          background: #ECECEC;
          border: 0;
          padding: 10px 30px;
          border-radius: 5px;
          font-weight: 500;
          // width: calc(50% - 10px);
          width: auto;
          min-width: 100px;
          margin-bottom: 10px;
          @media screen and (max-width: 1800px) {
            font-size: 14px;
            padding: 10px 30px;
          }
          @media screen and (max-width: 1300px) {
            font-size: 12px;
            padding: 8px 18px;
          }
          &.active {
            background: #674BD2;
            color: #fff;
          }
        }
      }
      .addToCart {
        // position: absolute;
        // left: 0;
        // bottom: 0;
        padding: 0px;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        // height: 240px;
        overflow: hidden;
        @media screen and (max-width: 1800px) {
          // height: 155px;
        }
        @media screen and (max-width: 1300px) {
          // height: 130px;
        }
        .totalsOptions {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          span {
            &:first-of-type {
              font-size: 14px;
              font-weight: 400;
            }
            &:last-of-type {
              font-size: 18px;
              font-weight: 600;
            }
          }
        }
        .total {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 10px;
          span {
            &:first-of-type {
              font-size: 26px;
              font-weight: 600;
              @media screen and (max-width: 1800px) {
                font-size: 24px;
              }
              @media screen and (max-width: 1500px) {
                font-size: 20px;
              }
              @media screen and (max-width: 1300px) {
                font-size: 18px;
              }
            }
            &:last-of-type {
              font-size: 28px;
              font-weight: 600;
              @media screen and (max-width: 1800px) {
                font-size: 26px;
              }
              @media screen and (max-width: 1500px) {
                font-size: 22px;
              }
              @media screen and (max-width: 1300px) {
                font-size: 20px;
              }
            }
          }
        }
        .orderNow {
          font-size: 20px;
          background: #20C598;
          color: #fff;
          padding: 20px 40px;
          border: 0;
          border-radius: 10px;
          @media screen and (max-width: 1800px) {
            font-size: 18px;
            padding: 18px 38px;
          }
          @media screen and (max-width: 1300px) {
            font-size: 16px;
            padding: 10px 20px;
          }
          &:disabled,
          &[disabled] {
            opacity: 0.5;
          }
        }
      }
      .quantity {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-direction: row;
        width: 90px;
        button {
          display: flex;
          align-items: center;
          justify-content: center;
          color: #25396F;
          background: #fff;
          border: 1px solid #E3E3E3;
          border-radius: 100%;
          width: 35px;
          height: 35px;
          &:hover {
            background: #674BD2;
            color: #fff;
          }
          &:last-of-type {
            line-height: 0;
          }
        }
      }
    }
  }
  .isInEditMode {
    .middleSection {
      .productList_wrapper {
        height: 100%;
      }
    }
  }

  .tagg {
    display: flex;
    align-items: center;
    justify-content: center;
    outline: none;
    width: 100%;
    button {
      color: #fff;
      background: #674BD2;
      border: 2px solid #fff;
      border-radius: 20px;
      margin-right: 20px;
      margin-bottom: 20px;
      padding: 10px 20px;
      font-weight: 500;
      text-transform: uppercase;
      &.active {
        color: #674BD2;
        background: #fff;
      }
    }
    // select {
    //   width: 100%;
    //   padding: 5px 10px;
    //   box-shadow: 0;
    //   border-radius: 0;
    //   option {
    //     border-radius: 0;
    //   }
    //   &:focus-visible {
    //     outline: 0;
    //   }
    //   &:focus {
    //     outline: 0;
    //   }
    // }
  }
  .topBar {
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    height: 110px;
    background: #F4F6FF;
    border-radius: 14px;
    margin-bottom: 20px;
    .oneLocation,
    .oneTag {
      @media screen and (max-width: 1400px) {
        font-size: 12px;
      }
    }
    .topBar__left {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      padding: 10px 0px;

      // margin-left: -50px;
      // margin-right: -50px;
      // > div {
      //   margin-left: 50px;
      //   margin-right: 50px;
      // }
      // @media screen and (max-width: 1300px) {
      //   margin-left: -20px;
      //   margin-right: -20px;
      //   > div {
      //     margin-left: 20px;
      //     margin-right: 20px;
      //   }
      // }
      .title {
        font-size: 1rem;
        width: 10%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
      }
      .adress {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20%;
        cursor: pointer;
        height: calc(100% - 0px);
        flex-wrap: wrap;
        >span {
          margin-left: 30px;
        }
        button {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 60px;
          border: 0px;
          border-radius: 10px;
          background: #E6E6FF;
          &.active {
            background: #674BD2;
            span {
              color: #fff;
            }
          }
          span {
            margin: 0;
          }
        }
        &.disabled {
          opacity: 0.3;
          user-select: none;
          pointer-events: none;
        }
      }
      .client {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        flex-direction: column;
        button {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 60px;
          border: 0px;
          border-radius: 10px;
          background: #CAD6F3;
          span {
            margin: 0;
            font-weight: 500 !important;
          }
        }
        svg {
          @media screen and (max-width: 1800px) {
            width: 50px;
            height: 50px;
          }
          @media screen and (max-width: 1300px) {
            width: 40px;
            height: 40px;
          }
        }
        &.selected {
          button {
            background: #674BD2;
            span {
              color: #fff;
            }
          }
        }
        &.disabled {
          opacity: 0.3;
          user-select: none;
          pointer-events: none;
        }
        span {
          font-weight: 600;
          max-width: 100px;
          text-overflow: ellipsis;
          overflow: hidden;
          font-size: 15px;
          margin-bottom: 5px;
        }
      }
      .method_btns {
        display: flex;
        align-items: stretch;
        justify-content: center;
        width: auto;
        height: calc(100% - 0px);
        flex-wrap: wrap;
        >span {
          margin-left: 30px;
          margin-bottom: 5px;
        }
        .method_btns_wrapper {
          display: flex;
          align-items: stretch;
          justify-content: center;
          width: auto;
          margin-left: -10px;
          margin-right: -10px;
        }
        @media screen and (max-width: 1800px) {
          font-size: 12px;
        }
        .methodBtn {
          background: #E6E6FF;
          border: 0;
          padding: 10px 15px;
          border-radius: 10px;
          width: 180px;
          font-weight: 500;
          margin-left: 10px;
          margin-right: 10px;
          min-height: 60px;
          font-size: 15px;
          @media screen and (max-width: 1800px) {
            width: 120px;
          }
          @media screen and (max-width: 1500px) {
            padding: 8px 10px;
            width: 100px;
          }
          @media screen and (max-width: 1300px) {
            padding: 5px 8px;
            width: 90px;
          }
          &.active {
            background: #674BD2;
            color: #fff;
          }
          &:disabled {
            opacity: 0.5;
          }
        }
      }
      .loc {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20%;
        outline: none;
        height: calc(100% - 0px);
        flex-wrap: wrap;
        >span {
          margin-left: 30px;
        }
        select {
          width: 100%;
          padding: 5px 10px;
          box-shadow: 0;
          border-radius: 0;
          option {
            border-radius: 0;
          }
          &:focus-visible {
            outline: 0;
          }
          &:focus {
            outline: 0;
          }
        }
      }
    }
    .topBar__right {
      width: 10%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 10px;

      // width: 35%;
      // display: flex;
      // align-items: stretch;
      // justify-content: space-around;
      // background: #F9F9F9;
      // padding: 15px 10px;
    }
  }
  .zoom {
    cursor: pointer;
    position: absolute;
    top: 3px;
    right: 10px;
    svg {
      @media screen and (max-width: 1800px) {
        width: 48px;
        height: 50px;
      }
      @media screen and (max-width: 1300px) {
        width: 38px;
        height: 40px;
      }
    }
  }
  .productList::-webkit-scrollbar {
      width: 20px;
  }
  .productList::-webkit-scrollbar-thumb {
      border-radius: 100px;
      border: 5px solid transparent;
      background-clip: content-box;
      background-color: #674BD2;
  }
  .productList::-webkit-scrollbar-track {
      background-color: #e4e4e4;
      border-radius: 100px;
  }
  .scrollBtnProductList {
    position: relative;
    background: #674BD2;
    color: #fff;
    border: 0;
    padding: 10px 15px;
    border-radius: 10px;
    width: 100px;
    margin-left: 10px;
    margin-right: 10px;
    font-weight: bold;
    @media screen and (max-width: 1600px) {
      width: auto;
    }
    @media screen and (max-width: 1350px) {
      margin-left: 0;
      margin-right: 0;
      padding: 5px 10px;
    }
    // &.up {
    //   top: 0;
    // }
    // &.down {
    //   bottom: 0;
    // }
  }
  .productList {
    position: relative;
    width: 100%;
    height: calc(100% - 70px); // +10px For Custom Scrool
    overflow: auto;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: flex-start;
    margin-right: 10px; // For Custom Scrool
    .productcat {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      overflow: hidden;
      >span {
        width: 100%;
        border-bottom: 1px solid #000;
        padding-top: 20px;
        padding-bottom: 5px;
        padding-left: 10px;
        margin-bottom: 10px;
      }
    }
    .product {
      width: calc(20% - 20px);
      margin-left: 10px;
      margin-right: 10px;
      margin-bottom: 20px;
      position: relative;
      height: auto;
      display: flex;
      align-items: center;
      flex-direction: column;
      text-align: center;
      justify-content: space-between;
      border-radius: 16px;
      border: 1px solid #E4E8F9;

      background: #fff;
      padding-top: 0px;
      @media screen and (max-width: 1800px) {
        width: calc(25% - 20px);
      }
      @media screen and (max-width: 1400px) {
        width: calc(33.33% - 20px);
      }
      @media screen and (max-width: 1200px) {
        width: calc(50% - 20px);
      }
      @media screen and (max-width: 800px) {
        width: calc(100% - 20px);
      }
      .product_img_title {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        margin-top: 10px;
      }
      .productImage {
        width: 140px;
        height: 140px;
        background-size: cover !important;
        background-position: center !important;
        margin-bottom: 10px;
        border-radius: 16px;
        user-select: none;
      }
      img {
        border-radius: 10px;
        margin-bottom: 10px;
      }
      p {
        text-overflow: ellipsis;
        overflow: hidden;
        &.prod_title {
          font-size: 16px;
          font-weight: 500;
          color: #25396F;
        }
        &.prod_price {
          font-size: 14px;
          font-weight: 400;
        }
      }
    }
  }
</style>
<style lang="scss">
  .content,
  .content.no-spacing,
  .container-fluid,
  .ordersposContainer {
    height: 100%;
  }
  .productModal {
    .el-collapse-item__content {
      color: #25396F;
    }
    .productModal__wrapper {
      height: calc(100% - 100px);
      overflow: auto;
    }
    .productModal__wrapper::-webkit-scrollbar {
        width: 5px;
    }
    .productModal__wrapper::-webkit-scrollbar-thumb {
        border-radius: 100px;
        border: 0px solid transparent;
        background-clip: content-box;
        background-color: #674BD2;
    }
    .productModal__wrapper::-webkit-scrollbar-track {
        background-color: #e4e4e4;
        border-radius: 100px;
    }
    .photo {
      width: 100%;
      height: 400px;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      position: sticky;
      top: 0;
      z-index: 1;
      // max-width: 200px;
      // img {
      //   max-width: 100%;
      //   border-radius: 25px
      // }
    }
    .productModal__product {
      width: 100%;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      padding: 20px;
      border-top-right-radius: 30px;
      border-top-left-radius: 30px;
      margin-top: -30px;
      z-index: 23;
      background: #fff;
      z-index: 2;
      background: #fff;
      position: relative;
      .title__wraper {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        .title {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 10px;
          p:first-of-type {
            font-size: 23px;
            font-weight: 500;
            max-width: 70%;
            word-break: break-all;
          }
          p:last-of-type {
            font-size: 20px;
          }
        }
      }
    }
    .options__wrapper {
      display: flex;
      flex-direction: column;
      padding: 20px;
      z-index: 2;
      background: #fff;
      position: relative;
      p {
        font-size: 20px;
        font-weight: 500;
      }
      .option {
        margin-bottom: 20px;
        p {
          span {
            font-weight: 300;
            font-size: 0.6em;
          }
        }
        .options {
          display: flex;
          flex-wrap: wrap;
          >div {
            margin-right: 20px;
          }
          label {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 22px;
            margin-bottom: 20px;
            input {
              margin: 0;
              width: 30px;
              height: 30px;
            }
            input[type="file"] {
              width: auto;
              height: auto;
              font-size: 1.5rem;
            }
            span {
              font-size: 16px;
              font-weight: normal;
              margin-left: 5px;
              padding-bottom: 5px;
              padding-top: 5px;
            }
          }
        }
      }
    }
    .info__wrapper {
      display: flex;
      flex-direction: column;
      padding: 20px;
      z-index: 2;
      background: #fff;
      position: relative;
      p {
        font-size: 20px;
        font-weight: 500;
      }
      textarea {
        border: 1px solid #E3E3E3;
        border-radius: 10px;
        height: 110px;
        width: 100%;
        resize: vertical;
        padding: 10px;
      }
    }
    .other_info {
      padding-left: 20px;
      padding-right: 20px;
    }
    .footer {
      padding: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      .footer__quantity {
        width: 170px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        span {
          color: #25396F;
          font-size: 20px;
          margin-left: 20px;
          margin-right: 20px;
        }
        button {
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          background: rgba(132, 132, 132, 0.49);
          border: 0;
          border-radius: 100%;
          width: 50px;
          height: 50px;
          font-size: 28px;
          &:hover {
            background: #674BD2;
          }
        }
      }
      .footer__price {
        width: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        span {
          font-size: 20px;
          margin-right: 10px;
          font-weight: 500;
          &:last-of-type {
            font-size: 28px;
          }
        }
      }
      .footer__addToCart {
        width: 150px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        button {
          color: #fff;
          font-weight: 500;
          font-size: 20px;
          border: 0px solid #707070;
          border-radius: 10px;
          background: #20C598;
          padding: 20px 40px;
          &:disabled {
              opacity: 0.5;
          }
        }
      }
    }
  }
  .payModal {
    .modal-content {
        box-shadow: none;
        border: none;
        height: 100%;
      .actionTitle {
        p {
          padding-top: 20px;
          font-size: 22px;
          text-align: center;
        }
      }
      .actionButton {
        display: flex;
        grid-gap: 1rem;
        grid-template-columns: 29% 29% 29%;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        margin-top: 30px;
      }
    }
  }
  .comment-modal {
    .modal-content {
        box-shadow: none;
        border: none;
        height: 100%;
        .title {
          font-size: 22px;
          text-align: center;
        }
        .modal-header {
          border: none;
        }
        textarea {
          resize: none;
          width: 100%;
          height: 100px;
          padding: 5px 10px;
          border: 1px solid #CAD6F3;
          border-radius: 14px;
          &:focus,
          &:focus-visible {
              outline: 0;
          }
        }
        .modal-footer {
          border: none;
          button {
            background: #DEF4EE;
            width: auto;
            height: 46px;
            font-size: 14px;
            text-transform: initial;
            padding: 10px 15px !important;
            line-height: 25px;
            min-width: 130px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #17B086;
            border: none;
            border-radius: 50px;
            margin: auto;
          }
        }
      .actionTitle {
        p {
          padding-top: 20px;
          font-size: 22px;
          text-align: center;
        }
      }
    }
  }
  .adressModal .content {
    height: calc(100% - 230px);
  }
  .comment-modal,
  .payModal,
  .adressModal,
  .userModal {
    z-index: 5;
    .vm--modal {
      // width: 70% !important;
      background: #F9F9F9;
    }
    .add_client_wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 5px;
      .add_client {
        border: 0;
        background: transparent;
        color: #20C598;
        font-weight: 500;
      }
    }
    .add_adress_wrapper {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      margin-bottom: 5px;
      .add_adress {
        border: 0;
        background: transparent;
        color: #20C598;
        font-weight: 500;
      }
    }
    h3 {
      font-weight: 500;
      margin-bottom: 20px;
    }
    input {
      width: 100%;
      margin-bottom: 20px;
      padding: 15px;
      padding-left: 20px;
      padding-right: 20px;
      border-radius: 10px;
      border: 1px solid #E4E8F9;
      &.red {
        border-color: red;
        color: red;
        &::placeholder {
          color: red;
          opacity: 1;
        }
        &:-ms-input-placeholder {
          color: red;
        }
        &::-ms-input-placeholder {
          color: red;
        }
      }
    }
    .header {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      background: #674BD2;
      height: 140px;
      h2 {
        font-size: 22px;
        font-weight: 500;
        color: #fff;
      }
      .search {
        width: 70%;
        position: relative;
        input {
          border-radius: 50px;
          padding-left: 70px;
          padding-right: 50px;
        }
        >svg {
          position: absolute;
          left: 3px;
          top: -4px;
          width: 47px;
        }
        .closeSearch {
          height: 33px;
          position: absolute;
          right: 7px;
          top: calc(50% - 26px);
          opacity: 0;
          transition: 0.5s;
          &.show {
            opacity: 1;
            transition: 0.5s;
          }
          svg {
            width: auto;
            height: 100%;
          }
        }
      }
    }
    .content {
      padding: 80px;
      padding-top: 10px;
      padding-bottom: 10px;
      display: flex;
      flex-direction: column;
      background: #F9F9F9;
      overflow: auto;
      .content_scrool {
      }
    }
    .fields__wrapper {
      display: flex;
      width: 100%;
      flex-direction: column;
      .fields {
        // width: calc(50% - 10px);
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        >div {
          width: calc(50% - 10px);
        }
      }
      .datepicker {
        .el-date-editor.el-input, .el-date-editor.el-input__inner {
          width: 140px;
        }
        span {
          margin-bottom: 10px;
        }
        input {
          margin-bottom: 30px;
        }
        label {
          display: flex;
          align-items: flex-start;
          justify-content: flex-start;
          flex-flow: column;
          .el-input__suffix,
          .el-input__prefix {
            height: auto;
          }
        }
      }
      .sex {
        position: relative;
        border: 1px solid #E4E8F9;
        border-radius: 10px;
        padding: 5px 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 220px;
        height: 40px;
        margin-bottom: 5px;
        margin-left: 20px;
        background: #fff;
        .sex__title {
          position: absolute;
          left: 0;
          top: -27px;
        }
        label {
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 0;
          input {
            width: 15px;
            height: 15px;
            margin: 0;
            margin-right: 7px;
          }
        }
      }
      .addAccount {
        label {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 250px;
          input {
            width: auto;
            margin: 0;
            margin-right: 10px;
          }
        }
      }
    }
    .userModal__clients {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-direction: column;
      width: 100%;
      background: #fff;
      padding-top: 20px;
      padding-bottom: 10px;
      max-height: 500px;
      overflow: auto;
      position: absolute;
      left: 0;
      top: 140px;
      z-index: 3;
      border-bottom-left-radius: 40px;
      border-bottom-right-radius: 40px;
      box-shadow: 5px 5px 10px -5px rgba(0, 0, 0, 0.75);
      .client {
        background: #F9F9F9;
        border: 1px solid #E4E8F9;
        border-radius: 10px;
        width: 90%;
        margin-bottom: 10px;
        padding: 15px 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .client__details {
          span {
            font-size: 20px;
            font-weight: normal;
            color: #25396F;
          }
        }
        .client__adress {
          span {
            font-size: 16px;
            font-weight: normal;
            color: #25396F;
          }
        }
      }
    }
    .addresses {
      display: flex;
      flex-wrap: wrap;
      align-items: stretch;
      justify-content: space-between;
      // max-height: 305px;
      // overflow: auto;
      // min-height: 95px;
      .deleteAdress__wrapper {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        width: 100%;
        position: absolute;
        right: 10px;
        bottom: 30px;
        z-index: 2;
      }
      .deleteAdress {
        background: red;
        color: #fff;
        border: 0;
        border-radius: 50px;
        padding: 2px 10px;
      }
      .adr2 {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-between;
        position: relative;
        width: calc(50% - 10px);
      }
      .adr {
        cursor: pointer;
        border: 1px solid #E4E8F9;
        border-radius: 10px;
        margin-bottom: 20px;
        padding: 10px 20px;
        background: #fff;
        // width: calc(50% - 10px);
        width: 100%;
        height: 100%;
        padding-bottom: 40px;

        transition: 0.5s;

        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        &:hover {
          transition: 0.5s;
          border: 1px solid #E4E8F9;
          background: #eae5ff;
          color: #25396F;
        }
        &.selected {
          border: 1px solid #E4E8F9;
          background: #674BD2;
          color: #fff;
        }
        p {
          margin: 0;
        }
      }
    }
  }
  .userModal__footer {
    display: flex;
    align-items: center;
    // justify-content: flex-end;
    justify-content: center;
    padding: 10px 80px;
    width: 100%;
    position: sticky;
    left: 0;
    bottom: 0;
    background: #F4F6FF;
    height: 90px;
    button {
      padding: 20px 55px;
      background: #20C598;
      color: #fff;
      border: 0;
      border-radius: 10px;
      font-size: 20px;
    }
  }
  .select_default {
    display: flex;
    align-items: center;
    // justify-content: flex-end;
    justify-content: center;
    button {
      padding: 10px 20px;
      background: #20C598;
      color: #fff;
      border: 0;
      border-radius: 10px;
      font-size: 20px;
    }
  }
  .dateSelect {
    padding: 40px;
    height: calc(100% - 90px);
    overflow: auto;
    input {
      width: 100%;
      max-width: 220px;
    }
    .directBtns {
      display: flex;
      margin-top: 20px;
      button {
        border: 0;
        padding: 10px 20px;
        margin-right: 20px;
        border-radius: 10px;
        background-color: #E6E6FF;
        &.active{
          color: #fff;
          background: #674BD2;
        }
      }
    }
  }
  .available_hours_today {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      width: 100%;
      max-width: 220px;
      outline: none;
      select {
        width: 100%;
        padding: 5px 10px;
        box-shadow: 0;
        border-radius: 0;
        border: 1px solid #E3E3E3;
        option {
          border-radius: 0;
        }
        &:focus-visible {
          outline: 0;
        }
        &:focus {
          outline: 0;
        }
      }
  }
  // .onPos {
  //   .main-panel {
  //     width: calc(100% - 250px);
  //   }
  //   .sidebar {
  //     margin: 10px;
  //     border-radius: 10px;
  //     height: calc(100% - 20px);
  //   }
  //   &.sidebar-mini {
  //     .main-panel {
  //       width: calc(100% - 90px);
  //     }
  //   }
  //   .sidebar .sidebar-wrapper > .nav .logout-link,
  //   .off-canvas-sidebar .sidebar-wrapper > .nav .logout-link {
  //     bottom: 20px;
  //   }

  //   // sidebar active
  //   .sidebar .sidebar-wrapper > .nav li > a, .off-canvas-sidebar .sidebar-wrapper > .nav li > a {
  //     padding-left: 20px;
  //     padding-right: 20px;
  //   }
  //   .sidebar-wrapper.ps.ps--theme_default.ps--active-x {
  //     padding-left: 10px;
  //   }
  //   .sidebar-wrapper.ps.ps--theme_default.ps--active-x .user{
  //     margin-left: -10px;
  //   }
  //   .sidebar-wrapper.ps.ps--theme_default.ps--active-x .logout-link{
  //     margin-left: -10px;
  //   }
  //   i.icon-menu.icon-menu-logout{
  //     margin-left: 10px;
  //   }
  //   li.router-link-exact-active.active {
  //     background: #F2F2F2;
  //     border-top-left-radius: 40px;
  //     border-bottom-left-radius: 40px;
  //   }
  //   //**

  //FullWidth/height
  // .container-fluid {
  //   position: absolute;
  //   width: 100%;
  //   height: 100%;
  //   margin: 0;
  //   padding: 0;
  // }
  .ordersposContainer {
    width: 100%;
    height: 100%;
  }
  .orderspos {
    overflow: auto;
    padding: 0;
  }
    //**
  // }

  .print-fiscal-buttons {
    width: 100%;
    display: grid;
    grid-gap: 1rem;
    grid-template-columns: 20% 20% 23%;
    text-align: center;
    background: #fff;
    display: flex;
    flex-direction: column;
    .orderWithPaymentButton {
      font-size: 17px;
      background: #20C598;
      color: #fff;
      padding: 20px 10px;
      border: 0;
      border-radius: 10px;
      height: 65px;
      margin-bottom: 0px;
      &.cash {
        background: #674BD2;
      }
      &.blue {
        background: #0097FC !important;
      }
      &.orange {
        background: orange !important;
      }
      @media screen and (max-width: 1800px) {
        font-size: 18px;
      }
      @media screen and (max-width: 1300px) {
        font-size: 16px;
      }
      &:disabled,
      &[disabled] {
        opacity: 0.5;
      }
    }
    .pay-button {
      background: #20C598;
      color: #fff;
      padding: 20px 10px;
      border: 0;
      border-radius: 10px;
      height: 65px;
      margin-bottom: 10px;
      width: 100%;
      max-width: 300px;
      margin: auto;
      margin-top: 20px;
      margin-bottom: 10px;
    }
    input {
      width: 100%;
      border-radius: 50px;
      border: 1px solid #CAD6F3;
      width: 100%;
      padding: 0px 20px;
    }
  }

  .orderWithPaymentButton {
      font-size: 17px;
      background: #20C598;
      color: #fff;
      padding: 20px 10px;
      border: 0;
      border-radius: 10px;
      height: 85px;
      margin-bottom: 0px;
      width: 300px;
      &.noPos {
        width: 450px;
        background: #20C598 !important;
      }
      &.cash {
        background: #674BD2 !important;
        width: 450px;
      }
      &.card {
        width: 300px;
      }
      &.blue {
        background: #0097FC !important;
      }
      &.orange {
        background: orange !important;
      }
      @media screen and (max-width: 1800px) {
        font-size: 18px;
      }
      @media screen and (max-width: 1300px) {
        font-size: 16px;
      }
      &:disabled,
      &[disabled] {
        opacity: 0.5;
      }
    }

  .print-fiscal-buttons :nth-child(1) {
    grid-column:span 4;
    height: 40px;
    margin-top: 0px;
  }
  .print-fiscal-buttons :nth-child(2) {
    grid-column:span 2;
  }
  .vm--modal {
    overflow: auto !important;
    border-radius: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/OrdersPos/OrdersPos.vue